/**
 * Buybox-2 Main Component
 * Step 1 inline on product page + Step 2 side drawer popup
 * Based on buybox-1 but adapted for inline/popup structure
 */

/**
 * Immediate carousel visibility fix - runs before DOMContentLoaded
 * Shows the correct carousel based on URL variant to prevent flicker
 */
(function() {
  'use strict';

  function getDefaultFlavorKey() {
    return typeof FlavorDistribution !== 'undefined'
      ? FlavorDistribution.getDefaultFlavorId()
      : 'rund';
  }

  // Variant ID to flavor key mapping (matches flavor-config.js)
  const variantToFlavor = {
    '53009094541576': 'rund',    // Beef
    '53009094574344': 'kip',     // Chicken
    '53009094607112': 'vis'      // Fish
  };
  
  // Flavor key to color scheme mapping (matches flavor-config.js)
  const flavorToColorScheme = {
    'rund': 'beef',
    'kip': 'chicken',
    'vis': 'fish'
  };
  
  /**
   * Get variant ID from URL
   */
  function getVariantFromURL() {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('variant') || null;
  }
  
  /**
   * Get flavor key from variant ID
   */
  function getFlavorFromVariantId(variantId) {
    return variantToFlavor[variantId] || getDefaultFlavorKey();
  }
  
  /**
   * Apply border color to active flavor card
   */
  function applyActiveFlavorBorder(flavorKey) {
    const flavorsContainer = document.querySelector('#buybox-2-flavors');
    if (!flavorsContainer) return;

    if (
      document.body.classList.contains('wizard-2-onetime-page') ||
      document.getElementById('buybox-3-inline')
    ) {
      const allCards = flavorsContainer.querySelectorAll('.buybox-2-flavor-card');
      allCards.forEach(function (card) {
        card.style.borderColor = '';
        card.style.borderWidth = '';
      });
      return;
    }
    
    const colorScheme = flavorToColorScheme[flavorKey];
    if (!colorScheme) return;
    
    // Remove border from all flavor cards
    const allCards = flavorsContainer.querySelectorAll('.buybox-2-flavor-card');
    allCards.forEach(function(card) {
      card.style.borderColor = '';
      card.style.borderWidth = '';
    });
    
    // Find the active flavor card and apply border
    // The card should have a data attribute or class that identifies its flavor
    const activeCard = flavorsContainer.querySelector('[data-flavor="' + flavorKey + '"]') ||
                       flavorsContainer.querySelector('.buybox-2-flavor-card[data-flavor="' + flavorKey + '"]');
    
    if (activeCard) {
      activeCard.style.borderColor = 'var(--color-' + colorScheme + '-500)';
      activeCard.style.borderWidth = '2px';
    }
  }
  
  /**
   * Show correct carousel and apply border color immediately
   */
  function showCorrectCarousel() {
    const variantId = getVariantFromURL();
    const flavorKey = variantId ? getFlavorFromVariantId(variantId) : getDefaultFlavorKey();
    
    // Hide all carousels
    const allCarousels = document.querySelectorAll('.instant-gallery-rund, .instant-gallery-kip, .instant-gallery-vis');
    allCarousels.forEach(function(carousel) {
      carousel.style.display = 'none';
    });
    
    // Show the correct carousel
    const activeCarousel = document.querySelector('.instant-gallery-' + flavorKey);
    if (activeCarousel) {
      activeCarousel.style.display = '';
    }
    
    // Apply border color to active flavor card
    applyActiveFlavorBorder(flavorKey);
  }
  
  /**
   * Run immediately if DOM is ready, otherwise wait for it
   */
  function initCarouselVisibility() {
    if (document.readyState === 'loading') {
      // DOM is still loading, wait for it
      document.addEventListener('DOMContentLoaded', showCorrectCarousel);
    } else {
      // DOM is ready, run immediately
      showCorrectCarousel();
    }
    
    // Also use MutationObserver to catch carousels and flavor cards that appear later
    if (typeof MutationObserver !== 'undefined') {
      const observer = new MutationObserver(function() {
        showCorrectCarousel();
      });
      
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
          observer.observe(document.body, {
            childList: true,
            subtree: true
          });
        });
      } else {
        observer.observe(document.body, {
          childList: true,
          subtree: true
        });
      }
    }
  }
  
  // Start immediately
  initCarouselVisibility();
})();

/**
 * When true, step 2 (bulk popup) is skipped: add-to-cart runs from step 1 with bulk 1×.
 * Default: true. Set `window.__buybox2SkipStep2 = false` in a script that runs before buybox-2.js loads to show step 2 again.
 */
const BUYBOX2_DEFAULT_SKIP_STEP_2 = true;

function buybox2ShouldSkipStep2() {
  if (typeof window !== 'undefined' && typeof window.__buybox2SkipStep2 === 'boolean') {
    return window.__buybox2SkipStep2;
  }
  return BUYBOX2_DEFAULT_SKIP_STEP_2;
}

function buybox2WizardOnetime() {
  return typeof window !== 'undefined' ? window.__wizard2OnetimeBuybox : null;
}

function isBuybox2WizardOnetime() {
  return !!(buybox2WizardOnetime() && buybox2WizardOnetime().enabled);
}

const Buybox2 = {
  // Step 1 inline elements
  inline: null,
  content: null,
  footer: null,
  loading: null,
  announcer: null,
  
  // Step 2 popup elements
  popup: null,
  popupInner: null,
  popupContent: null,
  popupFooter: null,
  popupAnnouncer: null,
  
  // Track if cart was added (for auto-add on close)
  _cartAdded: false,
  activeElement: null,
  
  // State management
  state: {
    currentStep: 'flavors', // 'flavors' or 'bulk'
    flavors: {
      rund: { quantity: 1, selected: true },
      kip: { quantity: 1, selected: true },
      vis: { quantity: 1, selected: true }
    },
    activeFlavor: null, // 'rund', 'kip', or 'vis' - for gallery/border styling
    deliveryMode: 'subscription', // 'subscription' or 'onetime'
    sellingPlan: '28', // Days: 28, 56, or 84
    dogWeights: [18], // kg per dog; length matches dogCount
    dogCount: 1,
    prices: {}, // Fetched from GraphQL
    currencyCode: 'EUR', // Set from API response; used for formatting
    totals: {
      base: 0,
      final: 0
    },
    selectedBulkOption: 1, // 1, 2, or 3
    pricePeriod: 'day' // 'day', 'week', or 'box'
  },
  
  // Product configuration (auto-detected from URL)
  PRODUCT: {
    handle: null,
    productId: null,
    variants: {
      rund: null,
      kip: null,
      vis: null
    }
  },
  
  // Storefront API configuration
  STOREFRONT_CONFIG: {
    shopDomain: 'sfddbc-hq.myshopify.com',
    apiVersion: '2023-10',
    accessToken: '60f4926a33fc4dbc1e55d7db722de43f'
  },
  
  // Selling plans mapping (loaded from config/selling-plans.json)
  sellingPlansMapping: null,
  freebieSellingPlanId: '',
  freebieGuideVariantId: 0,
  freebieScoopVariantId: 0,
  
  // Async operation tracking
  activeRequests: {
    priceFetch: null
  },
  
  // Scroll prevention properties
  currentScrollPosition: 0,
  preventTouchHandler: null,
  preventWheelHandler: null,
  touchStartHandler: null,
  touchEndHandler: null,
  lastTouchY: undefined,
  
  // Logger for debugging
  Logger: {
    _isProduction: window.location.hostname !== 'localhost',
    
    log(...args) {
      if (!this._isProduction) {
        console.log('[Buybox-2]', ...args);
      }
    },
    
    warn(...args) {
      if (!this._isProduction) {
        console.warn('[Buybox-2 WARN]', ...args);
      }
    },
    
    error(message, error) {
      // Always log errors to console for debugging, even in production
      console.error('[Buybox-2 ERROR]', message, error);
    }
  },
  
  /**
   * Get translation from Shopify locale
   */
  getTranslation(key, fallback = '') {
    if (!key) return fallback || '';
    // Translations are passed from Liquid via window.BuyboxTranslations2
    const translations = window.BuyboxTranslations2 || {};
    const value = translations[key];
    if (typeof value === 'string' && value.trim().length > 0) {
      return value;
    }
    return fallback || '';
  },
  
  /**
   * Format price in current market currency using shared formatMoney helper
   */
  formatPrice(amount) {
    if (typeof window.formatMoney !== 'function') {
      return `€${Number(amount).toFixed(2).replace('.', ',')}`;
    }
    return window.formatMoney(amount, this.state.currencyCode, window.BuyboxConfig2?.locale);
  },
  
  /**
   * Get pluralized text based on count
   */
  getPluralizedText(count, singularKey, pluralKey) {
    const translations = window.BuyboxTranslations2 || {};
    const singular = translations[`buybox2.step1.stock_calculator_${singularKey}`] || singularKey;
    const plural = translations[`buybox2.step1.stock_calculator_${pluralKey}`] || pluralKey;
    return count === 1 ? singular : plural;
  },
  
  /**
   * Format selling plan frequency in weeks format
   * @param {number} frequencyDays - Frequency in days (e.g., 28, 56, 84)
   * @returns {string} Formatted string (e.g., "Elke 4 weken" or "Every 4 weeks")
   */
  formatSellingPlanInWeeks(frequencyDays) {
    const weeks = frequencyDays / 7; // Always whole number (4, 8, 12, 16, 24, 36)
    const template = this.getTranslation('buybox2.step2.frequency_weeks', `Every ${weeks} weeks`);
    return template.replace(/{weeks}/g, weeks);
  },
  
  /**
   * Ensure dogWeights array matches dogCount: pad with 18 when growing, trim to first N when shrinking.
   */
  ensureDogWeights() {
    const count = Math.max(1, Math.min(10, this.state.dogCount || 1));
    let weights = this.state.dogWeights || [18];
    if (weights.length < count) {
      weights = [...weights, ...Array(count - weights.length).fill(18)];
    } else if (weights.length > count) {
      weights = weights.slice(0, count);
    }
    this.state.dogWeights = weights;
  },
  
  /**
   * Calculate stock notice recommendation: bag count closest to target days.
   * Target: base frequency (28/56/84) for subscription, 28 for one-time.
   * Bag count: whole bags where stockdays is closest to target.
   */
  calculateStockNotice() {
    this.ensureDogWeights();
    const dogWeights = this.state.dogWeights;
    const dogCount = this.state.dogCount || 1;
    const deliveryMode = this.state.deliveryMode || 'subscription';
    
    const daysPerBag = this.calculateDaysPerBagFromWeights(dogWeights);
    
    // Target days: base frequency for subscription, 28 for one-time
    const targetDays = deliveryMode === 'subscription'
      ? parseInt(this.state.sellingPlan, 10) || 28
      : 28;
    
    // Find whole bag count where stockdays is closest to targetDays
    let bestBagCount = 1;
    let bestDiff = Math.abs(daysPerBag - targetDays);
    for (let bags = 2; bags <= 50; bags++) {
      const stockdays = bags * daysPerBag;
      const diff = Math.abs(stockdays - targetDays);
      if (diff < bestDiff) {
        bestDiff = diff;
        bestBagCount = bags;
      }
    }
    
    const stockdays = Math.round(bestBagCount * daysPerBag);
    const stockdaysDisplay = Math.max(1, stockdays);
    
    const frequency = deliveryMode === 'subscription'
      ? (this.formatSellingPlanInWeeks(targetDays) || '').toLowerCase()
      : null;
    
    return {
      dogWeights,
      dogCount,
      bagCount: bestBagCount,
      stockdaysDisplay,
      deliveryMode,
      frequency
    };
  },
  
  /**
   * Calculate days per bag using Introbox-V2 energy-based formula (per-dog weights)
   * @param {number[]} dogWeights - Array of dog weights in kg
   * @returns {number} Days per bag
   */
  calculateDaysPerBagFromWeights(dogWeights) {
    const weights = Array.isArray(dogWeights) && dogWeights.length > 0
      ? dogWeights.map(w => Math.max(1, Math.min(100, Math.round(w) || 18)))
      : [18];
    
    const ME_KCAL_PER_GRAM = 4.50503;
    const UNDERFEED_FACTOR = 0.9;
    const ageFactor = 1.0;
    const activityFactor = 1.6;
    const neuterFactor = 1.0;
    const bodyCompositionFactor = 1.0;
    const treatFactor = 0.95;
    
    let dailyFoodGTotal = 0;
    for (const validWeight of weights) {
      const rer = 70 * Math.pow(validWeight, 0.75);
      const mer = rer * ageFactor * activityFactor * neuterFactor * bodyCompositionFactor;
      const dailyKcal = mer * treatFactor * UNDERFEED_FACTOR;
      const dailyFoodGPerDog = dailyKcal / ME_KCAL_PER_GRAM;
      dailyFoodGTotal += dailyFoodGPerDog;
    }
    
    if (dailyFoodGTotal <= 0) {
      this.Logger.warn('Invalid dailyFoodGTotal, using fallback');
      return 1;
    }
    
    const daysPerBag = 1000 / dailyFoodGTotal;
    if (!isFinite(daysPerBag) || daysPerBag <= 0) {
      this.Logger.warn('Invalid daysPerBag calculated, using fallback');
      return 1;
    }
    return daysPerBag;
  },
  
  /**
   * Calculate expected days of stock for bulk options
   * @param {number} multiplier - Bulk option multiplier (1, 2, or 3)
   * @returns {number} Expected days (minimum 1)
   */
  calculateExpectedDays(multiplier) {
    try {
      this.ensureDogWeights();
      const { dogWeights, flavors } = this.state;
      
      // Validate multiplier
      const validMultiplier = Math.max(1, Math.min(3, multiplier || 1));
      
      // Calculate total quantity (bags)
      let totalQuantity = 0;
      Object.values(flavors).forEach(flavor => {
        if (flavor.selected) {
          totalQuantity += flavor.quantity;
        }
      });
      
      if (totalQuantity === 0) {
        return 1; // Minimum expected days
      }
      
      const daysPerBag = this.calculateDaysPerBagFromWeights(dogWeights);
      
      // Use raw value (no Math.ceil) to preserve 1:2:3 ratio for accurate per-day/week pricing
      const rawDays = daysPerBag * totalQuantity * validMultiplier;
      const result = Math.max(1, rawDays);
      
      if (!isFinite(result) || result <= 0) {
        this.Logger.warn('Invalid expectedDays calculated, using fallback');
        return 1;
      }
      
      return result;
    } catch (error) {
      this.Logger.warn('Error in calculateExpectedDays, using fallback:', error);
      return 1; // Safe fallback
    }
  },
  
  /**
   * Load selling plans mapping from centralized config
   */
  async loadSellingPlans() {
    try {
      // Get selling plans URL from Liquid-rendered config (uses asset_url filter for proper CDN URL)
      const sellingPlansUrl = window.BuyboxAssetUrls2?.sellingPlans || '/assets/selling-plans.json';
      
      if (!sellingPlansUrl) {
        const errorMsg = 'Selling plans URL not configured. Check buybox-2-inline.liquid.';
        this.Logger.error(errorMsg);
        this.sellingPlansMapping = null;
        this.freebieSellingPlanId = '';
        this.freebieGuideVariantId = 0;
        this.freebieScoopVariantId = 0;
        return;
      }
      
      const response = await fetch(sellingPlansUrl);
      
      if (!response.ok) {
        // If 404, the file might not be uploaded yet - keep as null to indicate failure
        const errorMsg = `Selling plans config not found (${response.status}). URL: ${sellingPlansUrl}`;
        this.Logger.warn(errorMsg);
        // Keep as null (not empty object) so validation can detect the failure
        this.sellingPlansMapping = null;
        this.freebieSellingPlanId = '';
        this.freebieGuideVariantId = 0;
        this.freebieScoopVariantId = 0;
        return;
      }
      
      const data = await response.json();
      this.sellingPlansMapping = data.sellingPlanMapping || {};
      this.freebieSellingPlanId = String(data.freebieSellingPlanId || '').trim();
      this.freebieGuideVariantId = parseInt(String((data.freebieVariantIds && data.freebieVariantIds[0]) || ''), 10) || 0;
      this.freebieScoopVariantId = parseInt(String((data.freebieVariantIds && data.freebieVariantIds[1]) || ''), 10) || 0;
      const keyCount = Object.keys(this.sellingPlansMapping).length;
      this.Logger.log('Selling plans loaded:', keyCount);
      
      // Warn if mapping is empty after successful load
      if (keyCount === 0) {
        this.Logger.warn('Selling plans mapping is empty after loading');
      }
    } catch (error) {
      const errorMsg = 'Failed to load selling plans';
      this.Logger.error(errorMsg, error);
      // Keep as null (not empty object) so validation can detect the failure
      this.sellingPlansMapping = null;
      this.freebieSellingPlanId = '';
      this.freebieGuideVariantId = 0;
      this.freebieScoopVariantId = 0;
    }
  },
  
  /**
   * Get selling plan ID for given days
   */
  getSellingPlanId(days) {
    // Check if mapping is null/undefined OR empty
    if (!this.sellingPlansMapping || Object.keys(this.sellingPlansMapping).length === 0) {
      const status = !this.sellingPlansMapping ? 'not loaded (null)' : 'empty';
      console.warn(`[Buybox-1] Selling plans mapping ${status}. Cannot get selling plan for ${days} days.`);
      this.Logger.warn(`Selling plans mapping ${status}. Cannot get selling plan for ${days} days.`);
      return null;
    }
    
    const daysKey = String(days);
    const sellingPlanId = this.sellingPlansMapping[daysKey] || null;
    
    if (!sellingPlanId) {
      const availableKeys = Object.keys(this.sellingPlansMapping).slice(0, 10).join(', ');
      console.warn(`[Buybox-1] No selling plan found in mapping for ${days} days. Available keys: ${availableKeys}...`);
      this.Logger.warn(`No selling plan found in mapping for ${days} days. Available keys: ${availableKeys}...`);
    }
    
    return sellingPlanId;
  },
  
  /**
   * Convert numeric ID to GID format
   * @param {string|number} id - Numeric ID
   * @param {string} type - Resource type (default: 'SellingPlan')
   * @returns {string} GID format: gid://shopify/SellingPlan/123
   */
  toGid(id, type = 'SellingPlan') {
    return `gid://shopify/${type}/${id}`;
  },
  
  /**
   * Detect product handle from URL
   */
  detectProductHandle() {
    try {
      const configured = window.BuyboxConfig2?.productHandle;
      if (configured) return configured;
      if (isBuybox2WizardOnetime()) return 'forever-food';

      // Handle edge cases: trailing slash, query params, etc.
      const pathParts = window.location.pathname.split('/').filter(p => p);
      let productHandle = pathParts[pathParts.length - 1];
      
      // Remove query params if any
      productHandle = productHandle.split('?')[0];
      // Remove hash if any
      productHandle = productHandle.split('#')[0];
      // Trim whitespace
      productHandle = productHandle.trim();
      
      if (!productHandle || productHandle === '') {
        this.Logger.error('Could not detect product handle from URL');
        return null;
      }
      
      // Check if we're on a product page
      if (!window.location.pathname.includes('/products/')) {
        return null;
      }
      
      return productHandle;
    } catch (error) {
      this.Logger.error('Error detecting product handle', error);
      return null;
    }
  },
  
  /**
   * Auto-detect variants for buybox-2.
   * For forever-food: uses known variant IDs (single source of truth, locale-independent).
   * For other products: matches by option values Rund/Kip/Vis (legacy path).
   */
  detectVariants(product) {
    const FOREVER_FOOD_VARIANTS = {
      rund: '53009094541576',  // Beef
      kip: '53009094574344',   // Chicken
      vis: '53009094607112'    // Fish
    };

    if (product.handle === 'forever-food') {
      return FOREVER_FOOD_VARIANTS;
    }

    const flavorMap = {
      rund: 'Rund',
      kip: 'Kip',
      vis: 'Vis'
    };
    
    const detectedVariants = {};
    let allFound = true;
    const missingVariants = [];
    
    Object.entries(flavorMap).forEach(([flavorKey, optionValue]) => {
      const variant = product.variants.edges.find(edge => {
        const node = edge.node;
        return node.selectedOptions.some(option => option.value === optionValue);
      });
      
      if (variant) {
        const variantId = variant.node.id.split('/').pop();
        detectedVariants[flavorKey] = variantId;
      } else {
        allFound = false;
        missingVariants.push(`${flavorKey} (looking for option value: "${optionValue}")`);
        this.Logger.warn(`Variant not found for flavor: ${flavorKey} (option value: ${optionValue})`);
      }
    });
    
    if (!allFound) {
      const errorMsg = `Could not detect all required variants. Missing: ${missingVariants.join(', ')}. Please ensure product has variants with option values exactly: Rund, Kip, Vis (case-sensitive)`;
      throw new Error(errorMsg);
    }
    
    return detectedVariants;
  },
  
  /**
   * Get variant ID from URL parameter
   * @returns {string|null} Variant ID or null if not found
   */
  getVariantFromURL() {
    const urlParams = new URLSearchParams(window.location.search);
    const variantId = urlParams.get('variant');
    return variantId || null;
  },
  
  /**
   * Get flavor key from variant ID using flavor-config
   * @param {string} variantId - Variant ID
   * @returns {string|null} Flavor key (rund, kip, vis) or null
   */
  getFlavorFromVariantId(variantId) {
    if (typeof getFlavorFromVariantId === 'function') {
      return getFlavorFromVariantId(variantId);
    }
    // Fallback: check PRODUCT.variants mapping
    for (const [flavorKey, mappedVariantId] of Object.entries(this.PRODUCT.variants)) {
      if (mappedVariantId === variantId) {
        return flavorKey;
      }
    }
    return null;
  },
  
  /**
   * Update URL with variant ID, preserving other parameters
   * @param {string} variantId - Variant ID to set
   */
  updateURLWithVariant(variantId) {
    if (isBuybox2WizardOnetime()) return;
    const url = new URL(window.location.href);
    if (variantId) {
      url.searchParams.set('variant', variantId);
    } else {
      url.searchParams.delete('variant');
    }
    window.history.pushState({}, '', url.toString());
  },
  
  /**
   * Set active flavor and update URL
   * @param {string} flavorKey - Flavor key (rund, kip, vis)
   */
  setActiveFlavor(flavorKey) {
    if (!flavorKey || !this.PRODUCT.variants[flavorKey]) {
      this.Logger.warn('Invalid flavor key for setActiveFlavor:', flavorKey);
      return;
    }
    
    const previousActiveFlavor = this.state.activeFlavor;
    this.state.activeFlavor = flavorKey;
    
    const variantId = this.PRODUCT.variants[flavorKey];
    if (!isBuybox2WizardOnetime()) {
      this.updateURLWithVariant(variantId);
      this.updateInstantVariant(variantId);
    }
    
    // Show/hide carousels based on active flavor (immediate, no delay)
    this.updateCarouselVisibility(flavorKey);
    
    // Apply border colors if flavor cards are already rendered
    if (previousActiveFlavor !== flavorKey) {
      this.applyActiveFlavorBorder();
    }
    
    this.Logger.log('Active flavor set to:', flavorKey, 'variant:', variantId);
  },
  
  /**
   * Update carousel visibility based on active flavor
   * @param {string} flavorKey - Flavor key (rund, kip, vis)
   */
  updateCarouselVisibility(flavorKey) {
    // Hide all carousels
    const allCarousels = document.querySelectorAll('.instant-gallery-rund, .instant-gallery-kip, .instant-gallery-vis');
    allCarousels.forEach(carousel => {
      carousel.style.display = 'none';
    });
    
    // Show the active flavor's carousel
    const activeCarousel = document.querySelector(`.instant-gallery-${flavorKey}`);
    if (activeCarousel) {
      activeCarousel.style.display = '';
      this.Logger.log('Carousel visibility updated for flavor:', flavorKey);
    } else {
      this.Logger.warn('Carousel not found for flavor:', flavorKey, 'Expected class: .instant-gallery-' + flavorKey);
    }
  },
  
  /**
   * Update Instant form data attributes silently (no events)
   * This keeps Instant's data in sync without triggering its evaluation cycle
   * @param {string} variantId - Variant ID (numeric string)
   */
  updateInstantVariant(variantId) {
    if (!variantId) {
      this.Logger.warn('No variant ID provided to updateInstantVariant');
      return;
    }
    
    // Find Instant root form element
    const instantForm = document.querySelector('form[data-instant-type="root"]');
    if (instantForm) {
      // Update data-instant-form-variant-id attribute silently (no events)
      instantForm.setAttribute('data-instant-form-variant-id', variantId);
      this.Logger.log('Updated Instant form variant ID (silent):', variantId);
    } else {
      this.Logger.warn('Instant form element not found');
    }
    
    // Find Instant container div with data-instant-form-variant-id
    const instantContainer = document.querySelector('div[data-instant-form-variant-id]');
    if (instantContainer) {
      // Update data-instant-form-variant-id attribute silently (no events)
      instantContainer.setAttribute('data-instant-form-variant-id', variantId);
      this.Logger.log('Updated Instant container variant ID (silent):', variantId);
    } else {
      this.Logger.warn('Instant container element not found');
    }
  },
  
  /**
   * Apply flavor-specific border color to active flavor card
   */
  applyActiveFlavorBorder() {
    const flavorsContainer = this.content?.querySelector('#buybox-2-flavors');
    if (!flavorsContainer) return;

    if (isBuybox2WizardOnetime()) {
      const allCards = flavorsContainer.querySelectorAll('.buybox-2-flavor-card');
      allCards.forEach((card) => {
        card.style.borderColor = '';
      });
      return;
    }
    
    const activeFlavor = this.state.activeFlavor;
    if (!activeFlavor) return;
    
    // Get color scheme from flavor-config
    let colorScheme = null;
    if (typeof getColorSchemeFromFlavor === 'function') {
      colorScheme = getColorSchemeFromFlavor(activeFlavor);
    } else {
      // Fallback mapping
      const fallbackMap = {
        'rund': 'beef',
        'kip': 'chicken',
        'vis': 'fish'
      };
      colorScheme = fallbackMap[activeFlavor];
    }
    
    if (!colorScheme) {
      this.Logger.warn('No color scheme found for flavor:', activeFlavor);
      return;
    }
    
    // Remove border color from all cards
    const allCards = flavorsContainer.querySelectorAll('.buybox-2-flavor-card');
    allCards.forEach(card => {
      card.style.borderColor = '';
    });
    
    // Apply border color to active flavor card
    const activeCard = flavorsContainer.querySelector(`[data-flavor="${activeFlavor}"]`);
    if (activeCard && colorScheme) {
      activeCard.style.borderColor = `var(--color-${colorScheme}-500)`;
    }
  },
  
  /**
   * Initialize active flavor from URL or default (see flavor-distribution.js).
   */
  initializeActiveFlavor() {
    if (isBuybox2WizardOnetime()) {
      const defaultFlavor = FlavorDistribution.getDefaultFlavorId();
      this.state.activeFlavor = defaultFlavor;
      this.updateCarouselVisibility(defaultFlavor);
      return;
    }

    const variantId = this.getVariantFromURL();
    
    if (variantId) {
      const flavorKey = this.getFlavorFromVariantId(variantId);
      if (flavorKey) {
        this.state.activeFlavor = flavorKey;
        // Update carousel visibility on initialization
        this.updateCarouselVisibility(flavorKey);
        this.Logger.log('Active flavor initialized from URL:', flavorKey);
        return;
      }
    }
    
    const defaultFlavor = FlavorDistribution.getDefaultFlavorId();
    this.state.activeFlavor = defaultFlavor;
    this.updateCarouselVisibility(defaultFlavor);
    this.Logger.log('Active flavor initialized to default:', defaultFlavor);
  },
  
  /**
   * Fetch product from GraphQL Storefront API
   */
  async fetchProduct(handle) {
    try {
      const query = `
        query getProduct($handle: String!) {
          product(handle: $handle) {
            id
            handle
            title
            variants(first: 100) {
              edges {
                node {
                  id
                  title
                  selectedOptions {
                    name
                    value
                  }
                }
              }
            }
          }
        }
      `;
      
      const variables = { handle };
      const data = await this.executeGraphQL(query, variables);
      
      if (!data.product) {
        throw new Error(`Product not found: ${handle}`);
      }
      
      return data.product;
    } catch (error) {
      this.Logger.error('Error fetching product', error);
      throw error;
    }
  },
  
  /**
   * Initialize the component
   */
  async init() {
    this.inline = document.getElementById('buybox-2-inline');
    this.content = document.getElementById('buybox-2-content');
    this.footer = document.getElementById('buybox-2-footer');
    this.loading = document.getElementById('buybox-2-loading');
    this.announcer = document.getElementById('buybox-2-announcer');
    this.sticky = document.getElementById('buybox-2-sticky');
    this.popup = document.getElementById('buybox-2-popup');
    this.popupInner = this.popup?.querySelector('.buybox-2-popup__inner');
    this.popupContent = document.getElementById('buybox-2-popup-content');
    this.popupFooter = document.getElementById('buybox-2-popup-footer');
    this.popupAnnouncer = document.getElementById('buybox-2-popup-announcer');

    if (this._initialized) {
      if (isBuybox2WizardOnetime()) {
        this.state.deliveryMode = 'onetime';
        this.state.selectedBulkOption = 1;
        if (this.inline) this.inline.style.display = 'block';
        await this.renderContent();
        this.applyWizardOnetimeUi();
      }
      return;
    }

    if (buybox2ShouldSkipStep2() && this.popup) {
      this.popup.setAttribute('aria-hidden', 'true');
      this.popup.style.display = 'none';
    }
    
    if (!this.inline) {
      this.Logger.error('Buybox-2 inline element not found');
      return;
    }
    
    // Detect product from URL
    const productHandle = this.detectProductHandle();
    
    if (!productHandle) {
      // Silent fail - buybox-2 just doesn't appear
      return;
    }
    
    try {
      // Fetch product
      const product = await this.fetchProduct(productHandle);
      
      // Auto-detect variants
      const variants = this.detectVariants(product);
      
      // Set PRODUCT config
      this.PRODUCT.handle = product.handle;
      this.PRODUCT.productId = product.id.split('/').pop(); // Extract numeric ID from GID
      this.PRODUCT.variants = variants;
      
      this.Logger.log('Product detected:', this.PRODUCT);
    } catch (error) {
      // Show error for variant detection failure
      this.Logger.error('Failed to initialize product', error);
      if (this.inline) {
        this.inline.innerHTML = `<div style="padding: var(--spacing-md); color: var(--type-color-700);">${error.message || 'Failed to load product. Please refresh the page.'}</div>`;
        this.inline.style.display = 'block';
      }
      return;
    }
    
    // Load selling plans mapping
    await this.loadSellingPlans();
    
    // Restore state from localStorage (skip in wizard-2 one-time — we preselect from the plan)
    if (!isBuybox2WizardOnetime()) {
      this.restoreState();
    } else {
      this.state.deliveryMode = 'onetime';
      this.state.selectedBulkOption = 1;
    }
    
    if (buybox2ShouldSkipStep2()) {
      this.state.selectedBulkOption = 1;
    }
    
    // Initialize active flavor from URL (after restore so URL wins over stale localStorage)
    this.initializeActiveFlavor();
    
    // Show inline component
    this.inline.style.display = 'block';
    
    this.setupEventListeners();
    
    // Initial render
    if (this.content) {
      try {
        await this.renderContent();
      } catch (error) {
        this.Logger.error('Failed to render initial content', error);
        if (this.content) {
          this.content.innerHTML = `<div style="padding: var(--spacing-md); color: var(--type-color-700);">Error loading content: ${error.message}</div>`;
          this.content.style.display = 'block';
        }
      }
    }
    
    this._initialized = true;
    if (isBuybox2WizardOnetime()) this.applyWizardOnetimeUi();
    this.Logger.log('buybox-2_initialized');
  },

  applyWizardOnetimeUi() {
    if (!isBuybox2WizardOnetime()) return;
    document.getElementById('buybox-3-inline')?.classList.add('buybox-3-inline--active');
    this.inline?.classList.add('buybox-2-inline--wizard-onetime');
    const toggleWrap = this.footer?.querySelector('.buybox-2-delivery-toggle');
    if (toggleWrap) toggleWrap.style.display = 'none';
    const freq = this.footer?.querySelector('#buybox-2-frequency-selector');
    if (freq) freq.style.display = 'none';
    const delivery = this.footer?.querySelector('.buybox-2-delivery');
    if (delivery) delivery.style.display = 'none';
    const deliveryTitle = this.footer?.querySelector('.buybox-2-section-title');
    if (deliveryTitle) deliveryTitle.style.display = 'none';
    const benefits = this.footer?.querySelector('#buybox-2-benefits');
    if (benefits) benefits.style.display = 'none';
    if (this.footer) this.footer.style.display = 'none';
    if (this.sticky) this.sticky.style.display = 'none';
    const stockLink = this.content?.querySelector('#buybox-2-stock-calculator-link');
    if (stockLink) stockLink.style.display = 'none';
    const stockDropdown = this.content?.querySelector('#buybox-2-stock-calculator-dropdown');
    if (stockDropdown) stockDropdown.style.display = 'none';
    const flavorCards = this.content?.querySelectorAll('.buybox-2-flavor-card');
    flavorCards?.forEach((card) => {
      card.style.borderColor = '';
    });
    this.updateContinueButton();
  },
  
  /**
   * Setup event listeners
   */
  setupEventListeners() {
    // Step 2 popup close handlers
    this.setupStep2CloseHandlers();
    
    // Keyboard navigation for Step 2 popup
    document.addEventListener('keydown', (e) => {
      if (!this.popup || !this.popup.classList.contains('active')) return;
      
      if (e.key === 'Escape') {
        this.closeStep2Popup();
      }
    });
    
    // Setup Step 1 continue button (opens Step 2 popup)
    this.setupContinueButton();
    
    // Setup flavor card event delegation (called after rendering)
    // Note: setupFlavorCardEvents() is called from renderStep1(), not here
    
    // Setup delivery toggle (includes frequency selector setup)
    this.setupDeliveryToggle();
    
    // Setup stock calculator
    this.setupStockCalculator();
    
    // Setup sticky section (mobile: carousel + continue button)
    this.setupStickySection();
    
    // Note: Initial render is called from init() after setupEventListeners completes
    // This ensures all event listeners are set up before rendering
  },
  
  /**
   * Setup Step 2 popup close handlers (auto-add to cart)
   */
  setupStep2CloseHandlers() {
    if (!this.popup) return;
    
    // Close button
    const closeBtn = this.popup.querySelector('.buybox-2-popup__close');
    closeBtn?.addEventListener('click', () => {
      this.closeStep2Popup();
    });
    
    // Backdrop click
    const overlay = this.popup.querySelector('.buybox-2-popup__overlay');
    overlay?.addEventListener('click', () => {
      this.closeStep2Popup();
    });
  },
  
  /**
   * Show Step 2 popup
   */
  showStep2Popup() {
    if (buybox2ShouldSkipStep2()) return;
    if (!this.popup) return;
    
    // Reset cart added flag
    this._cartAdded = false;
    
    // Render Step 2 content
    this.renderStep2Content();
    
    // Show popup
    this.popup.style.display = 'flex';
    
    // Trigger animation
    setTimeout(() => {
      this.popup.classList.add('active');
      document.body.classList.add('overflow-hidden');
      
      // Focus trap
      if (typeof trapFocus === 'function') {
        const focusElement = this.popup.querySelector('.buybox-2-popup__close') || this.popupInner;
        trapFocus(this.popupInner, focusElement);
      }
    }, 10);
  },
  
  /**
   * Close Step 2 popup (with auto-add to cart)
   */
  async closeStep2Popup() {
    if (buybox2ShouldSkipStep2()) return;
    if (!this.popup) return;
    
    // ALWAYS add to cart when closing (unless already added via button)
    if (!this._cartAdded) {
      // Ensure bulk option is set (default to 1x if not selected)
      if (!this.state.selectedBulkOption) {
        this.state.selectedBulkOption = 1;
      }
      
      try {
        // Add to cart BEFORE closing
        await this.processCartAddition();
        
        // Success - mark as added, close popup, open cart drawer
        this._cartAdded = true;
        this._actuallyClosePopup();
        this.triggerCartDrawer();
      } catch (error) {
        // Error - keep popup open and show error
        this.Logger.error('Auto-add to cart failed on close', error);
        this.showError('Failed to add to cart. Please try again.');
        // Popup stays open - user can retry or use Add to Cart button
        return;
      }
    } else {
      // Already added via button, just close
      this._actuallyClosePopup();
    }
  },
  
  /**
   * Actually close popup (animation, focus trap removal, etc.)
   */
  _actuallyClosePopup() {
    if (!this.popup) return;
    
    // Remove active class
    this.popup.classList.remove('active');
    
    // Remove body scroll lock
    document.body.classList.remove('overflow-hidden');
    
    // Remove focus trap
    if (typeof removeTrapFocus === 'function') {
      removeTrapFocus(this.activeElement);
    }
    
    // Hide after animation
    setTimeout(() => {
      this.popup.style.display = 'none';
    }, 300); // Match transition duration
  },
  
  /**
   * Trigger cart drawer to open
   */
  async triggerCartDrawer(activeElement) {
    const cartDrawer = document.querySelector('cart-drawer');
    
    if (cartDrawer) {
      // Set active element for cart drawer (step 2 button, or step 1 continue when step 2 is skipped)
      const button =
        activeElement ||
        this.popupFooter?.querySelector('#buybox-2-add-to-cart') ||
        this.popupContent?.querySelector('#buybox-2-add-to-cart');
      if (button) {
        cartDrawer.setActiveElement(button);
      }
      
      // Fetch updated cart drawer content and open it
      try {
        const response = await fetch(`${window.routes.cart_url}?section_id=cart-drawer`);
        const responseText = await response.text();
        
        // Parse to get cart item count for parsedState.id
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const cartItems = html.querySelectorAll('cart-drawer-items .cart-item, cart-drawer-items tr[data-cart-item]');
        const itemCount = cartItems.length;
        
        // Structure parsedState like product-form.js does
        const parsedState = {
          id: itemCount > 0 ? 'cart-drawer' : null,
          sections: {
            'cart-drawer': responseText
          }
        };
        
        cartDrawer.renderContents(parsedState);
      } catch (error) {
        this.Logger.error('Failed to fetch cart drawer', error);
      }
    }
    // Trigger Instant cart drawer (when Automatic cart actions setup is disabled)
    window.Instant?.api?.updateCart?.();
    window.Instant?.api?.toggleCart?.(true);
  },
  
  /**
   * Show error message
   */
  showError(message) {
    // Simple error display - can be enhanced later
    if (this.popupAnnouncer) {
      this.popupAnnouncer.textContent = message;
    }
    alert(message);
  },
  
  /**
   * Render Step 2 content into popup
   */
  async renderStep2Content() {
    if (!this.popupContent) return;
    
    // Set current step to bulk for rendering
    const previousStep = this.state.currentStep;
    this.state.currentStep = 'bulk';
    
    // Temporarily swap content reference to popupContent
    const originalContent = this.content;
    this.content = this.popupContent;
    
    try {
      // Render Step 2 content
      const template = document.getElementById('buybox-2-step2-template');
      if (!template) {
        this.content = originalContent;
        return;
      }
      
      this.popupContent.innerHTML = '';
      this.popupContent.appendChild(template.content.cloneNode(true));
      
      // Render bulk options (uses this.content which is now popupContent)
      // Note: setupBulkOptionEventListeners is called inside renderBulkOptions - do not call again
      // (duplicate call would clone container a second time and reset period dropdowns)
      await this.renderBulkOptions();
      
      // Render Step 2 footer (uses popupFooter)
      this.renderFooterStep2();
      
      // Calculate pricing
      this.calculatePricing();
      
      // Update all pricing and price bars
      this.updateAll();
      
      // Update price bars (both Step 1 and Step 2)
      this.updatePriceBars();
    } finally {
      // Restore original content reference
      this.content = originalContent;
      // Restore previous step (we're not actually changing step, just rendering)
      this.state.currentStep = previousStep;
    }
  },
  
  /**
   * Setup event listeners for Step 2 popup close handlers
   */
  setupStep2CloseHandlers() {
    if (!this.popup) return;
    
    // Close button
    const closeButton = this.popup.querySelector('.buybox-2-popup__close');
    if (closeButton) {
      closeButton.addEventListener('click', () => {
        this.closeStep2Popup();
      });
    }
    
    // Backdrop click
    this.popup.addEventListener('click', (e) => {
      if (e.target === this.popup) {
        this.closeStep2Popup();
      }
    });
    
    // ESC key (handled in setupEventListeners)
  },
  
  /**
   * Setup touch handlers for mobile drag-to-close (if needed)
   * Note: Not implemented for buybox-2 as it uses cart drawer style popup
   */
  setupTouchHandlers() {
    // Touch handlers not needed for cart drawer style popup
    // Cart drawer handles its own touch interactions
    return;
  },
  
  /**
   * Open the modal
   */
  async open() {
    if (!this.modal) return;
    
    this.modal.classList.remove('closing');
    this.modal.setAttribute('aria-hidden', 'false');
    this.modal.style.display = 'flex';

    this.currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop;
    
    this.preventBackgroundScroll();
    
    await new Promise((resolve) => {
      requestAnimationFrame(() => {
        this.container.offsetHeight;
        resolve();
      });
    });
    
    this.modal.classList.add('active');
    this.modal.style.backdropFilter = 'blur(8px)';
    this.modal.style.webkitBackdropFilter = 'blur(8px)';

    document.body.classList.add('buybox-open');
    
    // Reset to step 1
    this.state.currentStep = 'flavors';
    
    // Render modal content
    await this.renderContent();
    
    const focusDelay = window.innerWidth < 750 ? 200 : 100;
    setTimeout(() => this.focusFirstElement(), focusDelay);
    
    // Track analytics
    this.trackEvent('buybox-2_opened');
    
    this.Logger.log('modal_opened');
  },
  
  /**
   * Close function removed - buybox-2 doesn't use modal
   * Step 2 popup uses closeStep2Popup() instead
   */
  
  /**
   * Prevent background scroll when modal is open
   */
  preventBackgroundScroll() {
    // Store current scroll position
    this.currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop;
    
    // Calculate scrollbar width BEFORE hiding it (to prevent layout shift)
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    
    // Apply padding-right to html to compensate for scrollbar space
    // This prevents layout shift when we hide the scrollbar
    if (scrollbarWidth > 0) {
      document.documentElement.style.paddingRight = `${scrollbarWidth}px`;
    }
    
    // Prevent scrolling by hiding overflow on html (not body)
    // This prevents scrolling without using position: fixed (which causes layout shift)
    document.documentElement.style.overflow = 'hidden';
    
    // Prevent touch scrolling on iOS
    this.preventTouchHandler = (e) => {
      // Allow scrolling inside buybox modal
      if (e.target.closest('.buybox-2-container')) {
        return;
      }
      
      // Prevent all other scrolling
      e.preventDefault();
    };
    
    document.addEventListener('touchmove', this.preventTouchHandler, { passive: false });
    
    // Prevent wheel scrolling
    this.preventWheelHandler = (e) => {
      // Allow scrolling inside buybox modal
      if (e.target.closest('.buybox-2-container')) {
        return;
      }
      
      e.preventDefault();
    };
    
    document.addEventListener('wheel', this.preventWheelHandler, { passive: false });
  },
  
  /**
   * Restore background scroll when modal is closed
   */
  restoreBackgroundScroll() {
    // Remove event listeners
    if (this.preventTouchHandler) {
      document.removeEventListener('touchmove', this.preventTouchHandler);
      this.preventTouchHandler = null;
    }
    
    if (this.preventWheelHandler) {
      document.removeEventListener('wheel', this.preventWheelHandler);
      this.preventWheelHandler = null;
    }
    
    // Restore html styles (remove overflow hidden and padding compensation)
    document.documentElement.style.overflow = '';
    document.documentElement.style.paddingRight = '';
    
    // Restore scroll position
    window.scrollTo(0, this.currentScrollPosition);
  },
  
  /**
   * Focus first element in modal
   */
  focusFirstElement() {
    const firstInput = this.modal.querySelector('button, input, select, a[href]');
    if (firstInput) {
      firstInput.focus();
    }
  },
  
  /**
   * Track analytics event
   */
  trackEvent(eventName, eventData = {}) {
    if (window.gtag) {
      window.gtag('event', eventName, {
        ...eventData,
        page: window.location.href
      });
    }
  },
  
  /**
   * Save state to localStorage
   */
  saveState() {
    if (isBuybox2WizardOnetime()) return;
    try {
      const locale = (document.documentElement?.getAttribute?.('lang') || 'en').split('-')[0];
      const country = (window.BuyboxConfig2?.countryCode || '').toUpperCase();
      const stateToSave = { ...this.state, _savedLocale: locale, _savedCountry: country };
      localStorage.setItem('buybox-2-state', JSON.stringify(stateToSave));
    } catch (error) {
      this.Logger.error('Failed to save state', error);
    }
  },
  
  /**
   * Restore state from localStorage
   */
  restoreState() {
    if (isBuybox2WizardOnetime()) return;
    try {
      const saved = localStorage.getItem('buybox-2-state');
      if (saved) {
        const parsed = JSON.parse(saved);
        const currentLocale = (document.documentElement?.getAttribute?.('lang') || 'en').split('-')[0];
        const currentCountry = (window.BuyboxConfig2?.countryCode || '').toUpperCase();
        const savedCountry = (parsed._savedCountry || '').toUpperCase();

        // Prices (including taglines) are locale-specific. Only restore if locale hasn't changed.
        if (!parsed._savedLocale || parsed._savedLocale !== currentLocale) {
          delete parsed.prices;
        }
        // Invalidate prices when country has changed (currency differs)
        if (savedCountry && currentCountry && savedCountry !== currentCountry) {
          delete parsed.prices;
          delete parsed.currencyCode;
        }
        delete parsed._savedLocale;
        delete parsed._savedCountry; // Don't merge metadata into state

        // Migrate dogWeight -> dogWeights (one-time)
        if (!parsed.dogWeights && parsed.dogWeight != null) {
          const count = Math.max(1, Math.min(10, parsed.dogCount || 1));
          parsed.dogWeights = Array(count).fill(Math.round(parsed.dogWeight) || 18);
          delete parsed.dogWeight;
        }

        // Merge with defaults
        this.state = {
          ...this.state,
          ...parsed,
          // Always reset currentStep to 'flavors' for inline content (Step 2 only renders in popup)
          currentStep: 'flavors',
          // Ensure defaults for flavors
          flavors: {
            rund: { quantity: parsed.flavors?.rund?.quantity || 1, selected: parsed.flavors?.rund?.selected !== false },
            kip: { quantity: parsed.flavors?.kip?.quantity || 1, selected: parsed.flavors?.kip?.selected !== false },
            vis: { quantity: parsed.flavors?.vis?.quantity || 1, selected: parsed.flavors?.vis?.selected !== false }
          }
        };
        // When base quantity < 3, daily period is hidden; override day → week
        if (!this.isDailyPeriodAvailable() && this.state.pricePeriod === 'day') {
          this.state.pricePeriod = 'week';
        }
      }
    } catch (error) {
      this.Logger.error('Failed to restore state', error);
    }
  },
  
  /**
   * Clear state from localStorage
   */
  clearState() {
    try {
      localStorage.removeItem('buybox-2-state');
    } catch (error) {
      this.Logger.error('Failed to clear state', error);
    }
  },
  
  /**
   * Execute GraphQL query
   */
  async executeGraphQL(query, variables = {}) {
    try {
      const headers = {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'X-Shopify-Storefront-Access-Token': this.STOREFRONT_CONFIG.accessToken
      };

      const response = await fetch('/api/2023-10/graphql.json', {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({
          query: query,
          variables: variables
        })
      });

      if (!response.ok) {
        throw new Error(`GraphQL request failed: ${response.statusText}`);
      }

      const data = await response.json();
      
      if (data.errors) {
        throw new Error(`GraphQL errors: ${JSON.stringify(data.errors)}`);
      }

      return data.data;
    } catch (error) {
      this.Logger.error('Error executing GraphQL', error);
      throw error;
    }
  },
  
  /**
   * Fetch product prices from GraphQL
   */
  async fetchPrices() {
    if (this.activeRequests.priceFetch) {
      return this.activeRequests.priceFetch;
    }
    
    const requestPromise = (async () => {
      try {
        const variantGids = Object.values(this.PRODUCT.variants).map(
          id => `gid://shopify/ProductVariant/${id}`
        );
        const languageCode = (document.documentElement?.getAttribute?.('lang') || 'en').split('-')[0].toUpperCase();
        const countryCode = (window.BuyboxConfig2?.countryCode || 'NL').toUpperCase();

        const query = `
          query getVariants($ids: [ID!]!, $language: LanguageCode, $country: CountryCode) @inContext(language: $language, country: $country) {
            nodes(ids: $ids) {
              ... on ProductVariant {
                id
                title
                price {
                  amount
                  currencyCode
                }
                compareAtPrice {
                  amount
                  currencyCode
                }
                availableForSale
                image {
                  url
                  altText
                }
                metafield(namespace: "custom", key: "tagline") {
                  value
                }
              }
            }
          }
        `;
        
        const data = await this.executeGraphQL(query, { ids: variantGids, language: languageCode, country: countryCode });
        
        const prices = {};
        variantGids.forEach((gid, index) => {
          const variant = data.nodes[index];
          if (variant) {
            const variantId = gid.split('/').pop();
            prices[variantId] = {
              price: parseFloat(variant.price.amount),
              compareAtPrice: variant.compareAtPrice ? parseFloat(variant.compareAtPrice.amount) : null,
              currencyCode: variant.price.currencyCode,
              availableForSale: variant.availableForSale,
              image: variant.image,
              title: variant.title,
              tagline: variant.metafield?.value || null
            };
          }
        });
        
        this.state.prices = prices;
        const firstVariant = Object.values(prices)[0];
        if (firstVariant && firstVariant.currencyCode) {
          this.state.currencyCode = firstVariant.currencyCode;
        }
        this.Logger.log('Prices fetched:', prices);
        
        return prices;
      } catch (error) {
        this.Logger.error('Failed to fetch prices', error);
        throw error;
      } finally {
        this.activeRequests.priceFetch = null;
      }
    })();
    
    this.activeRequests.priceFetch = requestPromise;
    return requestPromise;
  },
  
  /**
   * Calculate volume discount percentage
   * Uses Introbox-V2 formula: 1% per item starting from item 2, max 20%
   */
  calculateVolumeDiscount(totalItems) {
    return Math.min(20, Math.max(0, totalItems - 1));
  },

  /**
   * Combined automatic discount % (subscription + volume), identical on every variant’s unit.
   * Subscription: 10% + volume%. One-time: volume% only; single item one-time: 0%.
   * Matches Shopify SUB10 + BULK: one combined percent applied once (not sequential).
   */
  getCombinedDiscountPercent(totalQuantity, deliveryMode) {
    if (totalQuantity <= 0) return 0;
    const vol = this.calculateVolumeDiscount(totalQuantity);
    if (deliveryMode === 'subscription') {
      return 10 + vol;
    }
    if (totalQuantity === 1) return 0;
    return vol;
  },

  /**
   * Shopify automatic discount rounding: floor the discount amount, then subtract.
   * @param {number} amountCents
   * @param {number} percent
   * @returns {number}
   */
  applyShopifyPercentDiscountCents(amountCents, percent) {
    if (percent <= 0 || amountCents <= 0) return amountCents;
    const discountCents = Math.floor((amountCents * percent) / 100);
    return Math.max(0, amountCents - discountCents);
  },

  /**
   * Per-unit payable cents after Shopify-style combined discount (SUB10 + volume as one %).
   * @param {number} unitPriceCents
   * @param {string} deliveryMode
   * @param {number} totalQuantity
   * @returns {number}
   */
  discountedUnitCentsShopify(unitPriceCents, deliveryMode, totalQuantity) {
    const percent = this.getCombinedDiscountPercent(totalQuantity, deliveryMode);
    return this.applyShopifyPercentDiscountCents(unitPriceCents, percent);
  },

  /**
   * Per-variant price and compare-at subtotals in cents (Shopify variant price = payable basis for automatic discounts).
   * @param {number} bulkOption - Bulk multiplier 1, 2, or 3
   * @returns {{ priceSubtotalCents: number, compareSubtotalCents: number, totalQuantity: number }}
   */
  buildSubtotalsCents(bulkOption) {
    const bulk = bulkOption != null ? bulkOption : this.state.selectedBulkOption;
    const flavors = this.state.flavors || {};
    let priceSubtotalCents = 0;
    let compareSubtotalCents = 0;
    let totalQuantity = 0;

    FlavorDistribution.forEachFlavorKeyInOrder(flavors, (key, flavor) => {
      if (!flavor || !flavor.selected || flavor.quantity <= 0) return;
      const variantId = this.PRODUCT.variants[key];
      if (!variantId) return;
      const p = this.state.prices[variantId];
      if (!p || p.price == null || isNaN(p.price)) return;
      const qty = flavor.quantity * bulk;
      totalQuantity += qty;
      const unitPriceCents = Math.round(p.price * 100);
      priceSubtotalCents += unitPriceCents * qty;
      const comp =
        p.compareAtPrice != null && !isNaN(p.compareAtPrice)
          ? Math.round(p.compareAtPrice * 100)
          : unitPriceCents;
      compareSubtotalCents += comp * qty;
    });

    return { priceSubtotalCents, compareSubtotalCents, totalQuantity };
  },

  /**
   * Payable total in cents matching Shopify checkout: per variant line, apply combined
   * (subscription + volume) percent once with floored discount amounts, then sum line totals.
   * @param {number} bulkOption
   * @param {number} totalQuantity - Total bag count for volume tier
   * @param {string} deliveryMode
   * @returns {number}
   */
  sumDiscountedPayableCents(bulkOption, totalQuantity, deliveryMode) {
    const bulk = bulkOption != null ? bulkOption : this.state.selectedBulkOption;
    const mode = deliveryMode != null ? deliveryMode : this.state.deliveryMode;
    const flavors = this.state.flavors || {};
    let sumCents = 0;

    FlavorDistribution.forEachFlavorKeyInOrder(flavors, (key, flavor) => {
      if (!flavor || !flavor.selected || flavor.quantity <= 0) return;
      const variantId = this.PRODUCT.variants[key];
      if (!variantId) return;
      const p = this.state.prices[variantId];
      if (!p || p.price == null || isNaN(p.price)) return;
      const qty = flavor.quantity * bulk;
      const unitPriceCents = Math.round(p.price * 100);
      const discountedUnitCents = this.discountedUnitCentsShopify(
        unitPriceCents,
        mode,
        totalQuantity
      );
      sumCents += discountedUnitCents * qty;
    });

    return sumCents;
  },
  
  /**
   * Base quantity = sum of selected flavor quantities (bags from step 1).
   * Used to determine if daily price period is available (base >= 3).
   */
  getBaseQuantity() {
    let total = 0;
    Object.values(this.state.flavors || {}).forEach(flavor => {
      if (flavor && flavor.selected) {
        total += flavor.quantity || 0;
      }
    });
    return total;
  },
  
  /**
   * Daily price period is only shown when base quantity >= 3.
   * For 1–2 bags, rounding makes savings invisible; weekly is clearer.
   */
  isDailyPeriodAvailable() {
    return this.getBaseQuantity() >= 3;
  },
  
  /**
   * Calculate pricing for current state
   */
  /**
   * Calculate pricing for a given multiplier (does not mutate state)
   * @param {number} multiplier - Optional multiplier (defaults to selectedBulkOption)
   * @returns {Object} Pricing totals { base, final }
   */
  calculatePricingForMultiplier(multiplier = null) {
    const { deliveryMode } = this.state;
    const bulkOption = multiplier !== null ? multiplier : this.state.selectedBulkOption;

    const { priceSubtotalCents, compareSubtotalCents, totalQuantity } = this.buildSubtotalsCents(bulkOption);

    if (totalQuantity === 0 || priceSubtotalCents <= 0) {
      return { base: 0, final: 0 };
    }

    const finalCents = this.sumDiscountedPayableCents(bulkOption, totalQuantity, deliveryMode);
    const strikeCents = Math.max(compareSubtotalCents, priceSubtotalCents);

    return {
      base: strikeCents / 100,
      final: finalCents / 100
    };
  },
  
  /**
   * Calculate pricing and update state (uses selectedBulkOption from state)
   */
  calculatePricing() {
    const totals = this.calculatePricingForMultiplier();
    this.state.totals = totals;
    this.Logger.log('Pricing calculated:', this.state.totals);
  },
  
  /**
   * Get current unit price (after discounts)
   */
  getCurrentUnitPrice() {
    const { flavors, selectedBulkOption } = this.state;
    let totalQuantity = 0;
    Object.values(flavors).forEach(flavor => {
      if (flavor.selected) {
        totalQuantity += flavor.quantity;
      }
    });
    totalQuantity = totalQuantity * selectedBulkOption;
    
    if (totalQuantity === 0 || this.state.totals.final === 0) {
      return 0;
    }
    
    return this.state.totals.final / totalQuantity;
  },
  
  /**
   * Get minimum possible unit price (max discounts)
   */
  getMinimumUnitPrice() {
    const deliveryMode = this.state.deliveryMode || 'subscription';
    const maxVolumeQuantity = 21;
    let minUnitCents = Infinity;
    Object.keys(this.PRODUCT.variants || {}).forEach(key => {
      const id = this.PRODUCT.variants[key];
      const p = this.state.prices[id];
      if (!p || p.price == null || isNaN(p.price)) return;
      const uc = Math.round(p.price * 100);
      if (uc < minUnitCents) minUnitCents = uc;
    });
    if (!isFinite(minUnitCents)) return 0;
    const discountedCents = this.discountedUnitCentsShopify(
      minUnitCents,
      deliveryMode,
      maxVolumeQuantity
    );
    return discountedCents / 100;
  },
  
  /**
   * Get base unit price
   */
  getBaseUnitPrice() {
    const { priceSubtotalCents, compareSubtotalCents, totalQuantity } = this.buildSubtotalsCents(
      this.state.selectedBulkOption
    );
    if (totalQuantity === 0) return 0;
    return Math.max(compareSubtotalCents, priceSubtotalCents) / totalQuantity / 100;
  },
  
  /**
   * Render modal content based on current step
   */
  async renderContent() {
    if (!this.content) return;
    
    // Only show loading if we're on initial load (no prices) or if data is actually being fetched
    const needsPriceFetch = Object.keys(this.state.prices).length === 0;
    const isInitialLoad = needsPriceFetch;
    
    if (isInitialLoad) {
      this.showLoading();
    }
    
    try {
      // Fetch prices if not already loaded
      if (needsPriceFetch) {
        await this.fetchPrices();
      }
      
      // Render step content
      if (this.state.currentStep === 'flavors') {
        await this.renderStep1();
      } else if (this.state.currentStep === 'bulk') {
        await this.renderStep2();
      }
      
      // Update pricing
      this.calculatePricing();
      this.updatePricingDisplay();
      
      // Save state
      this.saveState();
    } catch (error) {
      this.Logger.error('Failed to render content', error);
      this.content.innerHTML = '<p>Error loading content. Please refresh the page.</p>';
    } finally {
      if (isInitialLoad) {
        this.hideLoading();
      }
    }
  },
  
  /**
   * Show loading overlay
   */
  showLoading() {
    if (this.loading) {
      this.loading.style.display = 'flex';
    }
  },
  
  /**
   * Hide loading overlay
   */
  hideLoading() {
    if (this.loading) {
      this.loading.style.display = 'none';
    }
  },
  
  /**
   * Render Step 1: Flavor Selection
   */
  async renderStep1() {
    const template = document.getElementById('buybox-2-step1-template');
    if (!template) {
      throw new Error('Step 1 template not found');
    }
    
    // Build step 1 content in a temporary container first (to avoid empty state)
    const tempContainer = document.createElement('div');
    tempContainer.appendChild(template.content.cloneNode(true));
    
    // Temporarily swap content reference so all methods work on temp container
    const originalContent = this.content;
    this.content = tempContainer;
    
    try {
      // No title update needed for inline (no modal header)
      
      // No back button for inline
      
      // Render flavor cards (works on temp container)
      await this.renderFlavorCards();
      
      // Setup flavor card event delegation
      this.setupFlavorCardEvents();
      
      // Setup stock calculator
      this.setupStockCalculator();
      
      // Setup continue button (will be called again after footer render, but this handles case where footer exists)
      this.setupContinueButton();
      
      // Restore original content reference
      this.content = originalContent;
      
      // Swap content in one operation (no empty state visible)
      // Content is already invisible due to transitioning class added in navigateToStep
      originalContent.replaceChildren(...Array.from(tempContainer.children));
      
      // Calculate pricing before updating price bar (ensures totals are current, not stale from localStorage)
      this.calculatePricing();
      
      // Update price bar now that content is swapped and pricing is calculated
      this.updatePriceBar();
      
      // Render footer (must be done before setting up delivery toggle, which is now in footer)
      this.renderFooterStep1();
      
      // Setup delivery toggle (now in footer, so must be done after footer is rendered)
      this.setupDeliveryToggle();
      
      // Update delivery UI to set initial state (package summary, toggle text, benefits visibility)
      this.updateDeliveryUI();
      
      // Update savings banner (now in footer)
      this.updateSavingsBanner();
      
      if (isBuybox2WizardOnetime()) this.applyWizardOnetimeUi();

      // Prefetch step 2 data in the background (non-blocking)
      this.prefetchStep2Data();
    } catch (error) {
      // Restore original content reference on error
      this.content = originalContent;
      throw error;
    }
  },
  
  /**
   * Render flavor cards
   */
  async renderFlavorCards() {
    const flavorsContainer = this.content.querySelector('#buybox-2-flavors');
    if (!flavorsContainer) return;
    
    const template = document.getElementById('buybox-2-flavor-card-template');
    if (!template) return;
    
    const flavorNames = {
      rund: this.getTranslation('buybox2.step1.flavor_rund', 'Rund'),
      kip: this.getTranslation('buybox2.step1.flavor_kip', 'Kip'),
      vis: this.getTranslation('buybox2.step1.flavor_vis', 'Vis')
    };
    
    flavorsContainer.innerHTML = '';
    
    FlavorDistribution.getFlavorDistributionOrder().forEach((key) => {
      const variantId = this.PRODUCT.variants[key];
      const flavor = this.state.flavors[key];
      const price = this.state.prices[variantId];

      if (!flavor || !price) return;
      
      const card = template.content.cloneNode(true);
      const cardElement = card.querySelector('.buybox-2-flavor-card');
      
      // Update card data
      cardElement.setAttribute('data-flavor', key);
      
      // Replace FLAVOR_KEY in all IDs within the cloned card
      const allElements = cardElement.querySelectorAll('[id*="FLAVOR_KEY"]');
      allElements.forEach(el => {
        if (el.id) {
          el.id = el.id.replace(/FLAVOR_KEY/g, key);
        }
      });
      
      // Also replace FLAVOR_KEY in data-flavor attributes
      const allDataFlavorElements = cardElement.querySelectorAll('[data-flavor="FLAVOR_KEY"]');
      allDataFlavorElements.forEach(el => {
        el.setAttribute('data-flavor', key);
      });
      
      // Update image
      const imageEl = cardElement.querySelector('.buybox-2-flavor-image img');
      if (imageEl && price.image) {
        imageEl.src = price.image.url;
        imageEl.alt = price.image.altText || flavorNames[key];
      }
      
      // Update name with accent classes
      const nameEl = cardElement.querySelector('.buybox-2-flavor-name');
      if (nameEl) {
        // Determine accent class based on flavor key
        let accentClass = '';
        if (key === 'rund') {
          accentClass = 'accent accent--beef shape_2 nowrap';
        } else if (key === 'kip') {
          accentClass = 'accent accent--chicken shape_3 nowrap';
        } else if (key === 'vis') {
          accentClass = 'accent accent--fish shape_4 nowrap';
        }
        
        if (accentClass) {
          nameEl.innerHTML = `<span class="${accentClass}">${flavorNames[key]}</span>`;
        } else {
          nameEl.textContent = flavorNames[key];
        }
      }
      
      // Update details link (opens Instant overlay via data-open-flavor-modal)
      const detailsLink = cardElement.querySelector('.buybox-2-flavor-details');
      if (detailsLink) {
        const modalValue = key === 'rund' ? 'beef' : key === 'kip' ? 'chicken' : 'fish';
        detailsLink.setAttribute('data-open-flavor-modal', modalValue);
        detailsLink.href = '#';
      }
      
      // Update tagline
      const taglineEl = cardElement.querySelector('.buybox-2-flavor-tagline');
      if (taglineEl && price.tagline) {
        taglineEl.textContent = price.tagline;
      }
      
      // Update quantity controls (now with correct IDs)
      const quantityEl = cardElement.querySelector(`#buybox-2-flavor-quantity-${key}`);
      const addButton = cardElement.querySelector(`#buybox-2-flavor-add-${key}`);
      const quantityValue = cardElement.querySelector(`#buybox-2-quantity-${key}`);
      
      if (flavor.selected && flavor.quantity > 0) {
        // Show quantity controls
        if (quantityEl) quantityEl.style.display = 'flex';
        if (addButton) addButton.style.display = 'none';
        if (quantityValue) quantityValue.textContent = `${flavor.quantity}`;
        
        // Add selected class
        cardElement.classList.add('buybox-2-flavor-card--selected');
      } else {
        // Show add button
        if (quantityEl) quantityEl.style.display = 'none';
        if (addButton) addButton.style.display = 'block';
        
        // Remove selected class
        cardElement.classList.remove('buybox-2-flavor-card--selected');
      }
      
      if (isBuybox2WizardOnetime()) {
        const bridge = buybox2WizardOnetime();
        const allergic = bridge.getAllergyFlavorIds?.() || [];
        if (allergic.includes(key)) {
          const warn = document.createElement('div');
          warn.className = 'inline-message wizard-2-onetime-allergy';
          warn.setAttribute('data-message-type', 'warning');
          const icon = document.createElement('span');
          icon.className = 'warning-icon';
          icon.setAttribute('aria-hidden', 'true');
          const iconUrl = bridge.warningIconUrl || '';
          if (iconUrl) {
            const img = document.createElement('img');
            img.src = iconUrl;
            img.alt = '';
            img.width = 16;
            img.height = 16;
            icon.appendChild(img);
          }
          const p = document.createElement('p');
          p.className = 'inline-message-text';
          p.textContent = bridge.allergyWarningText?.() || '';
          warn.appendChild(icon);
          warn.appendChild(p);
          const actions = cardElement.querySelector('.buybox-2-flavor-content');
          if (actions) actions.appendChild(warn);
          else cardElement.appendChild(warn);
        }
      }

      flavorsContainer.appendChild(card);
    });
    
    // Apply border colors based on active flavor
    this.applyActiveFlavorBorder();
  },
  
  /**
   * Setup event delegation for flavor card buttons
   */
  setupFlavorCardEvents() {
    const flavorsContainer = this.content.querySelector('#buybox-2-flavors');
    if (!flavorsContainer) return;
    
    // Use event delegation to handle clicks on dynamically rendered buttons
    flavorsContainer.addEventListener('click', (e) => {
      // Find the flavor card that contains the clicked element
      const card = e.target.closest('.buybox-2-flavor-card');
      if (!card) return;
      
      const flavorKey = card.getAttribute('data-flavor');
      const flavor = this.state.flavors[flavorKey];
      if (!flavor) return;
      
      // Update active flavor if clicking on a different flavor (any click on the card)
      // This includes clicks on buttons, so the gallery updates on first interaction
      if (!isBuybox2WizardOnetime() && this.state.activeFlavor !== flavorKey) {
        this.setActiveFlavor(flavorKey);
      }
      
      // Handle minus button
      if (e.target.classList.contains('buybox-2-quantity-btn--minus') || 
          e.target.closest('.buybox-2-quantity-btn--minus')) {
        e.preventDefault();
        e.stopPropagation();
        this.updateFlavorQuantity(flavorKey, flavor.quantity - 1);
        return;
      }
      
      // Handle plus button
      if (e.target.classList.contains('buybox-2-quantity-btn--plus') || 
          e.target.closest('.buybox-2-quantity-btn--plus')) {
        e.preventDefault();
        e.stopPropagation();
        this.updateFlavorQuantity(flavorKey, flavor.quantity + 1);
        return;
      }
      
      // Handle add button
      if (e.target.classList.contains('buybox-2-flavor-add') || 
          e.target.closest('.buybox-2-flavor-add')) {
        e.preventDefault();
        e.stopPropagation();
        this.updateFlavorQuantity(flavorKey, 1);
        return;
      }
    });
  },
  
  /**
   * Update flavor quantity
   */
  updateFlavorQuantity(flavorKey, quantity) {
    if (quantity < 0) quantity = 0;
    
    const flavor = this.state.flavors[flavorKey];
    if (!flavor) return;
    
    flavor.quantity = quantity;
    flavor.selected = quantity > 0;
    
    // Track analytics
    this.trackEvent('buybox-2_flavor_selected', {
      flavor: flavorKey,
      quantity: quantity
    });
    
    // Re-render and update
    this.renderFlavorCards();
    this.updateAll();
  },
  
  /**
   * Setup stock calculator
   */
  setupStockCalculator() {
    const link = this.content.querySelector('#buybox-2-stock-calculator-link');
    const dropdown = this.content.querySelector('#buybox-2-stock-calculator-dropdown');
    const content = this.content.querySelector('#buybox-2-stock-calculator-content');
    
    if (!link || !dropdown || !content) return;
    
    let isOpen = false;
    
    link.addEventListener('click', (e) => {
      e.preventDefault();
      isOpen = !isOpen;
      dropdown.style.display = isOpen ? 'block' : 'none';
      
      if (isOpen) {
        // Update stock notice when opening
        this.updateStockNotice();
      }
    });
    
    // Initial render (collapsed, but content ready)
    this.updateStockNotice();
  },
  
  /**
   * Update stock notice in dropdown (bag recommendation)
   * Subscription: "Voor X hond/honden van Y kg adviseren wij Z zakken {frequency}."
   * One-time: "Voor X hond/honden van Y kg adviseren wij Z zakken (±stockdays dagen voorraad)."
   */
  /**
   * Build HTML for per-dog weight selects: "sel1, sel2 & sel3" (commas, & before last)
   */
  buildDogWeightsSelectsHTML(prefix) {
    this.ensureDogWeights();
    const weights = this.state.dogWeights;
    const parts = [];
    weights.forEach((w, i) => {
      const rounded = Math.max(1, Math.min(100, Math.round(w) || 18));
      let options = '';
      for (let j = 1; j <= 100; j++) {
        options += `<option value="${j}" ${j === rounded ? 'selected' : ''}>${j}</option>`;
      }
      const sep = i < weights.length - 2 ? ', ' : (i === weights.length - 2 && weights.length > 1 ? ' & ' : '');
      parts.push(`<select id="${prefix}-dog-weight-${i + 1}" class="buybox-2-stock-notice-select">${options}</select>${sep}`);
    });
    return parts.join('');
  },
  
  updateStockNotice() {
    const stockNoticeContent = this.content?.querySelector('#buybox-2-stock-calculator-content');
    if (!stockNoticeContent) return;
    
    const calculation = this.calculateStockNotice();
    const { dogWeights, dogCount, bagCount, stockdaysDisplay, deliveryMode, frequency } = calculation;
    
    const dogWord = this.getPluralizedText(dogCount, 'dog_singular', 'dog_plural');
    const dayWord = this.getPluralizedText(stockdaysDisplay, 'day_singular', 'day_plural');
    const bagWord = bagCount === 1
      ? (this.getTranslation('buybox2.step1.package_summary_bag_singular', 'zak'))
      : (this.getTranslation('buybox2.step1.package_summary_bag_plural', 'zakken'));
    
    // Create dog count select (max 10)
    let dogCountOptions = '';
    for (let i = 1; i <= 10; i++) {
      dogCountOptions += `<option value="${i}" ${i === dogCount ? 'selected' : ''}>${i}</option>`;
    }
    
    const dogWeightsHTML = this.buildDogWeightsSelectsHTML('buybox-2');
    
    const translations = window.BuyboxTranslations2 || {};
    const templateKey = deliveryMode === 'subscription'
      ? 'buybox2.step1.stock_calculator_text_subscription'
      : 'buybox2.step1.stock_calculator_text_onetime';
    const defaultSub = 'Voor {dogCount} {dogWord} van {dogWeight} kg adviseren wij {bagcount} {bagWord} {frequency}.';
    const defaultOnetime = 'Voor {dogCount} {dogWord} van {dogWeight} kg adviseren wij {bagcount} {bagWord} (±{stockdays} {dayWord} voorraad).';
    let stockText = translations[templateKey] || (deliveryMode === 'subscription' ? defaultSub : defaultOnetime);
    
    stockText = stockText
      .replace(/{dogCount}/g, `<select id="buybox-2-dog-count" class="buybox-2-stock-notice-select">${dogCountOptions}</select>`)
      .replace(/{dogWord}/g, `<span class="buybox-2-stock-notice-dog-word">${dogWord}</span>`)
      .replace(/{dogWeight}/g, dogWeightsHTML)
      .replace(/{bagcount}/g, `<span class="buybox-2-stock-notice-bagcount">${bagCount}</span>`)
      .replace(/{bagWord}/g, `<span class="buybox-2-stock-notice-bag-word">${bagWord}</span>`)
      .replace(/{frequency}/g, `<span class="buybox-2-stock-notice-frequency">${frequency || ''}</span>`)
      .replace(/{stockdays}/g, `<span class="buybox-2-stock-notice-stockdays">${stockdaysDisplay}</span>`)
      .replace(/{dayWord}/g, `<span class="buybox-2-stock-notice-day-word">${dayWord}</span>`);
    
    stockNoticeContent.innerHTML = stockText;
    this.attachStockNoticeListeners();
  },
  
  /**
   * Update stock notice: bagcount, stockdays/frequency, pluralization, and select values
   * Updates even when dropdown is collapsed to keep selects in sync
   */
  updateStockNoticeDays() {
    const stockNoticeContent = this.content?.querySelector('#buybox-2-stock-calculator-content');
    if (!stockNoticeContent) return;
    
    const calculation = this.calculateStockNotice();
    const { dogWeights, dogCount, bagCount, stockdaysDisplay, deliveryMode, frequency } = calculation;
    
    const dogWord = this.getPluralizedText(dogCount, 'dog_singular', 'dog_plural');
    const dayWord = this.getPluralizedText(stockdaysDisplay, 'day_singular', 'day_plural');
    const bagWord = bagCount === 1
      ? (this.getTranslation('buybox2.step1.package_summary_bag_singular', 'zak'))
      : (this.getTranslation('buybox2.step1.package_summary_bag_plural', 'zakken'));
    
    const dogWordSpan = stockNoticeContent.querySelector('.buybox-2-stock-notice-dog-word');
    const bagcountSpan = stockNoticeContent.querySelector('.buybox-2-stock-notice-bagcount');
    const bagWordSpan = stockNoticeContent.querySelector('.buybox-2-stock-notice-bag-word');
    const frequencySpan = stockNoticeContent.querySelector('.buybox-2-stock-notice-frequency');
    const stockdaysSpan = stockNoticeContent.querySelector('.buybox-2-stock-notice-stockdays');
    const dayWordSpan = stockNoticeContent.querySelector('.buybox-2-stock-notice-day-word');
    
    if (dogWordSpan) dogWordSpan.textContent = dogWord;
    if (bagcountSpan) bagcountSpan.textContent = String(bagCount);
    if (bagWordSpan) bagWordSpan.textContent = bagWord;
    if (frequencySpan && deliveryMode === 'subscription') frequencySpan.textContent = frequency || '';
    if (stockdaysSpan && deliveryMode === 'onetime') stockdaysSpan.textContent = String(stockdaysDisplay);
    if (dayWordSpan && deliveryMode === 'onetime') dayWordSpan.textContent = dayWord;
    
    const dogCountSelect = stockNoticeContent.querySelector('#buybox-2-dog-count');
    if (dogCountSelect && dogCountSelect.value !== String(dogCount)) {
      dogCountSelect.value = String(dogCount);
    }
    
    dogWeights.forEach((w, i) => {
      const sel = stockNoticeContent.querySelector(`#buybox-2-dog-weight-${i + 1}`);
      const rounded = Math.max(1, Math.min(100, Math.round(w) || 18));
      if (sel && sel.value !== String(rounded)) {
        sel.value = String(rounded);
      }
    });
  },
  
  /**
   * Attach event listeners to stock notice inputs (event delegation)
   */
  attachStockNoticeListeners() {
    const stockNoticeContent = this.content?.querySelector('#buybox-2-stock-calculator-content');
    if (!stockNoticeContent) return;
    if (stockNoticeContent._stockListenersAttached) return;
    
    // Use event delegation - one listener for all changes
    const handleChange = (e) => {
      const target = e.target;
      if (target.id === 'buybox-2-dog-count') {
        const value = parseInt(target.value) || 1;
        const clampedCount = Math.max(1, Math.min(10, value));
        this.state.dogCount = clampedCount;
        this.ensureDogWeights();
        this.saveState();
        // Full re-render (number of weight selects changes)
        this.updateStockNotice();
        if (this.state.currentStep === 'bulk') {
          const bulkContent = this.popupContent?.querySelector('#buybox-2-bulk-stock-content-1') || this.content?.querySelector('#buybox-2-bulk-stock-content-1');
          if (bulkContent) this.renderBulkStockCalculator(bulkContent);
          this.updateBulkStockNoticeDays();
          this.updateAllBulkOptionPricing();
        }
        this.updateAll();
        return;
      }
      const weightMatch = target.id && target.id.match(/^buybox-2-dog-weight-(\d+)$/);
      if (weightMatch) {
        const index = parseInt(weightMatch[1], 10) - 1;
        const value = parseInt(target.value) || 18;
        const clampedValue = Math.max(1, Math.min(100, value));
        this.ensureDogWeights();
        if (this.state.dogWeights[index] !== undefined) {
          this.state.dogWeights[index] = clampedValue;
        }
        this.saveState();
        this.updateStockNoticeDays();
        if (this.state.currentStep === 'bulk') {
          this.updateBulkStockNoticeDays();
          this.updateAllBulkOptionPricing();
        }
        this.updateAll();
      }
    };
    
    stockNoticeContent.addEventListener('change', handleChange);
    stockNoticeContent._stockListenersAttached = true;
  },
  
  /**
   * Setup delivery toggle
   */
  setupDeliveryToggle() {
    const toggle = this.inline.querySelector('#buybox-2-delivery-toggle');
    
    if (!toggle) return;
    
    // Set initial toggle state (UI will be updated via updateDeliveryUI() called after this)
    toggle.checked = this.state.deliveryMode === 'subscription';
    
    toggle.addEventListener('change', (e) => {
      this.state.deliveryMode = e.target.checked ? 'subscription' : 'onetime';
      
      // Track analytics
      this.trackEvent('buybox-2_delivery_toggled', {
        mode: this.state.deliveryMode
      });
      
      this.updateDeliveryUI();
      this.updateAll();
    });
    
    // Frequency selector
    const frequencySelect = this.inline.querySelector('#buybox-2-frequency-select');
    if (frequencySelect) {
      // Set initial value (will also be set by updateDeliveryUI, but ensure it's correct)
      frequencySelect.value = this.state.sellingPlan;
      frequencySelect.addEventListener('change', (e) => {
        this.state.sellingPlan = e.target.value;
        this.updateAll();
      });
    }
  },
  
  /**
   * Update delivery UI elements
   */
  updateDeliveryUI() {
    const toggle = this.inline.querySelector('#buybox-2-delivery-toggle');
    const toggleText = this.inline.querySelector('#buybox-2-toggle-text');
    const frequencySelector = this.inline.querySelector('#buybox-2-frequency-selector');
    const benefits = this.inline.querySelector('#buybox-2-benefits');
    const packageSummary = this.inline.querySelector('#buybox-2-package-summary');
    const deliveryContainer = this.inline.querySelector('.buybox-2-delivery');
    
    if (this.state.deliveryMode === 'subscription') {
      // Remove onetime class, show subscription styling
      if (deliveryContainer) {
        deliveryContainer.classList.remove('buybox-2-delivery--onetime');
      }
      
      if (toggleText) {
        toggleText.textContent = this.getTranslation('buybox2.step1.subscription_toggle', 'Abonneer & bespaar');
      }
      if (frequencySelector) {
        frequencySelector.style.display = 'block';
      }
      // Ensure frequency select value is set correctly
      const frequencySelect = this.inline.querySelector('#buybox-2-frequency-select');
      if (frequencySelect) {
        frequencySelect.value = this.state.sellingPlan;
      }
      if (benefits) {
        benefits.style.display = 'block';
        this.renderBenefits(benefits);
      }
    } else {
      // Add onetime class for white card styling
      if (deliveryContainer) {
        deliveryContainer.classList.add('buybox-2-delivery--onetime');
      }
      
      if (toggleText) {
        toggleText.textContent = this.getTranslation('buybox2.step1.onetime_toggle', 'Bestel eenmalig');
      }
      if (frequencySelector) {
        frequencySelector.style.display = 'none';
      }
      if (benefits) {
        benefits.style.display = 'none';
      }
    }
    
    // Update package summary
    if (packageSummary) {
      this.updatePackageSummary(packageSummary);
    }

    this.updateRewardsPunchCard();
  },

  /**
   * Plan gifts punchcard under delivery info (rewards_v1:on + subscribe only).
   */
  updateRewardsPunchCard() {
    const root =
      (this.inline && this.inline.querySelector('[data-bz-sf-punch]')) ||
      document.querySelector('#buybox-2-footer [data-bz-sf-punch]');
    if (!root || !window.BzStorefrontPunch || typeof window.BzStorefrontPunch.render !== 'function') {
      if (root) root.hidden = true;
      return;
    }

    const planFlavors = [];
    FlavorDistribution.forEachFlavorKeyInOrder(this.state.flavors || {}, (key, flavor) => {
      const qty = parseInt(flavor && flavor.quantity, 10) || 0;
      if (flavor && flavor.selected && qty > 0) planFlavors.push(key);
    });

    const locale = (document.documentElement?.getAttribute?.('lang') || 'nl').split('-')[0];
    const subscribe = this.state.deliveryMode === 'subscription';
    const rewardsOn =
      typeof window.bzRewardsExperimentOn === 'function'
        ? window.bzRewardsExperimentOn()
        : false;

    window.BzStorefrontPunch.render(root, {
      planFlavors,
      allergies: [],
      locale: locale === 'en' ? 'en' : 'nl',
      visible: subscribe && rewardsOn,
      box1Freebies: { scoop: true, guide: true },
    });
  },
  
  /**
   * Render benefits section
   */
  renderBenefits(container) {
    if (!container) return;
    
    const benefits = [
      this.getTranslation('buybox2.step1.benefit_1', 'ALTIJD 10% KORTING'),
      this.getTranslation('buybox2.step1.benefit_2', 'NOOIT MEER NAAR DE WINKEL'),
      this.getTranslation('buybox2.step1.benefit_3', 'STOP GEMAKKELIJK'),
      this.getTranslation('buybox2.step1.benefit_4', 'UIT VOORRAAD BESCHERMING')
    ];
    
    container.innerHTML = `
      <ul class="buybox-2-benefits-list">
        <li class="buybox-2-benefits-column">
          <span>${benefits[0]}</span>
          <span>${benefits[2]}</span>
        </li>
        <li class="buybox-2-benefits-column">
          <span>${benefits[1]}</span>
          <span>${benefits[3]}</span>
        </li>
      </ul>
    `;
  },
  
  /**
   * Update package summary
   */
  updatePackageSummary(container) {
    if (!container) return;
    
    const { flavors } = this.state;
    let totalQuantity = 0;
    Object.values(flavors).forEach(flavor => {
      if (flavor.selected) {
        totalQuantity += flavor.quantity;
      }
    });
    
    // Get pluralized bag word
    const translations = window.BuyboxTranslations2 || {};
    const bagSingular = translations['buybox2.step1.package_summary_bag_singular'] || 'bag';
    const bagPlural = translations['buybox2.step1.package_summary_bag_plural'] || 'bags';
    const bagWord = totalQuantity === 1 ? bagSingular : bagPlural;
    
    const summaryText = this.getTranslation('buybox2.step1.package_summary', '{quantity} {bagWord} of 1kg')
      .replace('{quantity}', totalQuantity)
      .replace('{bagWord}', bagWord);
    
    container.textContent = summaryText;
  },
  
  /**
   * Add to cart from step 1 when step 2 is skipped (bulk 1×).
   */
  async addToCartFromStep1(button) {
    this.state.selectedBulkOption = 1;
    const label = button.querySelector('#buybox-2-continue-label');
    const originalText = label?.textContent || '';
    const loadingText = this.getTranslation('buybox2.step2.adding', 'Adding...');
    button.disabled = true;
    button.classList.add('loading');
    if (label) {
      label.textContent = loadingText;
    }
    try {
      await this.processCartAddition();
      await this.triggerCartDrawer(button);
    } catch (error) {
      this.Logger.error('Failed to add to cart from step 1', error);
      this.trackEvent('buybox-2_cart_failure', {
        error: error.message
      });
      if (label) {
        label.textContent = originalText;
      }
      alert(error.message || 'Er is een fout opgetreden bij het toevoegen aan de winkelwagen. Probeer het opnieuw.');
    } finally {
      button.disabled = false;
      button.classList.remove('loading');
      this.updateContinueButton();
    }
  },
  
  /**
   * Setup continue button
   */
  setupContinueButton() {
    // Button is in footer, not content
    const button = this.footer?.querySelector('#buybox-2-continue') || this.content.querySelector('#buybox-2-continue');
    if (!button) return;
    
    button.addEventListener('click', async () => {
      // Check if total quantity > 0
      const { flavors } = this.state;
      let totalQuantity = 0;
      Object.values(flavors).forEach(flavor => {
        if (flavor.selected) {
          totalQuantity += flavor.quantity;
        }
      });
      
      if (totalQuantity === 0) {
        return; // Button should be disabled
      }
      
      // Track analytics
      this.trackEvent('buybox-2_step_1_completed');
      
      if (isBuybox2WizardOnetime() && typeof buybox2WizardOnetime().checkout === 'function') {
        await buybox2WizardOnetime().checkout(button);
        return;
      }

      if (buybox2ShouldSkipStep2()) {
        await this.addToCartFromStep1(button);
      } else {
        this.showStep2Popup();
      }
    });
    
    // Update button state
    this.updateContinueButton();
  },
  
  /**
   * Setup sticky section (mobile only: carousel + continue button)
   */
  setupStickySection() {
    if (!this.sticky) return;
    const track = document.getElementById('buybox-2-sticky-carousel-track');
    const stickyButton = document.getElementById('buybox-2-sticky-continue');
    if (!track || !stickyButton) return;
    const realSlideCount = track.children.length;
    const firstSlide = track.children[0].cloneNode(true);
    track.appendChild(firstSlide);
    const slideCount = track.children.length;
    let currentSlide = 0;
    const advance = () => {
      currentSlide++;
      track.style.transition = 'transform 0.6s ease';
      track.style.transform = `translateX(-${currentSlide * 100}%)`;
      if (currentSlide === realSlideCount) {
        setTimeout(() => {
          track.style.transition = 'none';
          currentSlide = 0;
          track.style.transform = 'translateX(0)';
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              track.style.transition = 'transform 0.6s ease';
            });
          });
        }, 600);
      }
    };
    this._stickyCarouselInterval = setInterval(advance, 3000);
    stickyButton.addEventListener('click', () => {
      const realButton = this.footer?.querySelector('#buybox-2-continue');
      if (realButton && !realButton.disabled) {
        realButton.click();
      }
    });
  },
  
  /**
   * Update continue button state
   */
  updateContinueButton() {
    // Button is in footer, not content
    const button = this.footer?.querySelector('#buybox-2-continue') || this.content.querySelector('#buybox-2-continue');
    if (!button) return;
    
    const label = button.querySelector('#buybox-2-continue-label');
    const priceWrapper = button.querySelector('#buybox-2-continue-price');
    const compareEl = button.querySelector('#buybox-2-continue-compare');
    const finalEl = button.querySelector('#buybox-2-continue-final');
    
    const { flavors, deliveryMode } = this.state;
    let totalQuantity = 0;
    Object.values(flavors).forEach(flavor => {
      if (flavor.selected) {
        totalQuantity += flavor.quantity;
      }
    });
    
    button.disabled = totalQuantity === 0;
    
    let labelText = '';
    let showPrice = false;
    let compareTotal = 0;
    let finalTotal = 0;
    
    if (totalQuantity === 0) {
      labelText = this.getTranslation('buybox2.step1.button_disabled', 'Choose at least 1 flavor');
    } else {
      if (isBuybox2WizardOnetime()) {
        labelText = buybox2WizardOnetime().checkoutLabel || this.getTranslation('buybox2.step1.button_onetime', 'Checkout');
      } else if (deliveryMode === 'subscription') {
        labelText = this.getTranslation('buybox2.step1.button_subscription', 'Add subscription');
      } else {
        labelText = this.getTranslation('buybox2.step1.button_onetime', 'Add to cart');
      }
      showPrice = true;
      const totals1x = this.calculatePricingForMultiplier(1);
      compareTotal = totals1x.base;
      finalTotal = totals1x.final;
      if (isBuybox2WizardOnetime()) {
        const ship = window.wizard2Flow?.stepHandler?.getWizard2ShippingMoneyForCountry?.() || {};
        const threshold = Number(ship.freeShippingThreshold);
        const cut = Number.isFinite(threshold) ? threshold : 70;
        const shipping = Number(ship.shipping);
        const shipAmt = Number.isFinite(shipping) ? shipping : 0;
        if (shipAmt > 0) compareTotal += shipAmt;
        if (totals1x.final < cut && shipAmt > 0) finalTotal += shipAmt;
      }
    }
    
    if (label) label.textContent = labelText;
    if (priceWrapper) priceWrapper.style.display = totalQuantity === 0 ? 'none' : 'flex';
    if (finalEl && showPrice) finalEl.textContent = this.formatPrice(finalTotal);
    if (compareEl) {
      if (compareTotal === finalTotal) {
        compareEl.style.display = 'none';
      } else {
        compareEl.style.display = 'inline';
        compareEl.textContent = this.formatPrice(compareTotal);
      }
    }
    
    // Sync sticky button (mobile)
    const stickyButton = document.getElementById('buybox-2-sticky-continue');
    if (stickyButton) {
      stickyButton.disabled = totalQuantity === 0;
      const stickyLabel = stickyButton.querySelector('#buybox-2-sticky-continue-label');
      const stickyPriceWrapper = stickyButton.querySelector('#buybox-2-sticky-continue-price');
      const stickyCompare = stickyButton.querySelector('#buybox-2-sticky-continue-compare');
      const stickyFinal = stickyButton.querySelector('#buybox-2-sticky-continue-final');
      if (stickyLabel) stickyLabel.textContent = labelText;
      if (stickyPriceWrapper) stickyPriceWrapper.style.display = totalQuantity === 0 ? 'none' : 'flex';
      if (stickyFinal && showPrice) stickyFinal.textContent = this.formatPrice(finalTotal);
      if (stickyCompare) {
        if (compareTotal === finalTotal) {
          stickyCompare.style.display = 'none';
        } else {
          stickyCompare.style.display = 'inline';
          stickyCompare.textContent = this.formatPrice(compareTotal);
        }
      }
    }
  },
  
  /**
   * Place the moving bag price on the price bar.
   * Buybox-3 / wizard onetime: park its left edge after compare until the tag
   * reaches the current price's center, then move together.
   * Positions are always % of the labels row so re-entering the page (hidden host
   * → 480px column) cannot leave a stale pixel `left` outside the bar.
   */
  positionPriceBarCurrentLabel(priceBar, opts) {
    const labelsContainer = priceBar.querySelector('.buybox-2-price-bar-labels');
    const labelRightEl = opts.labelRightEl;
    const labelLeftEl = opts.labelLeftEl || priceBar.querySelector('.buybox-2-price-bar-label-left');
    const discountedValueEl = opts.discountedValueEl;
    const discountedUnitEl = opts.discountedUnitEl;
    const fillWidth = Number(opts.fillWidth) || 0;
    if (!labelsContainer || !labelRightEl) return;

    const labelsContainerWidth = labelsContainer.clientWidth || labelsContainer.offsetWidth;
    const notLaidOut = !labelsContainerWidth || labelsContainer.offsetParent === null;
    if (notLaidOut) {
      if (!this._priceBarMeasureRetry) {
        this._priceBarMeasureRetry = true;
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            this._priceBarMeasureRetry = false;
            this.updatePriceBars();
          });
        });
      }
      return;
    }

    const wasHidden = labelRightEl.style.display === 'none';
    if (wasHidden) {
      labelRightEl.style.display = 'flex';
      labelRightEl.style.visibility = 'hidden';
    }
    const boxWidth = labelRightEl.offsetWidth;
    if (wasHidden) labelRightEl.style.visibility = '';

    const spacingXs = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--spacing-xs')) || 4;
    const unitPriceEl = priceBar.querySelector('.buybox-2-price-bar-label-unit');
    const unitPriceWidth = unitPriceEl ? unitPriceEl.offsetWidth : 0;
    const leftBaseEl = labelLeftEl?.querySelector('.buybox-2-price-bar-base');
    const leftPriceWidth = leftBaseEl?.offsetWidth || labelLeftEl?.offsetWidth || 0;
    const actualRightWidth =
      (discountedValueEl?.offsetWidth || 0) + (discountedUnitEl?.offsetWidth || 0) || boxWidth;
    const tagCenterPx = (fillWidth / 100) * labelsContainerWidth;
    const useOnetimePark =
      isBuybox2WizardOnetime() || !!(priceBar.closest && priceBar.closest('#buybox-3-inline, .buybox-3-inline'));

    if (useOnetimePark) {
      const parkedLeftPx = Math.min(
        Math.max(0, leftPriceWidth + spacingXs),
        Math.max(0, labelsContainerWidth - actualRightWidth)
      );
      const parkedCenterPx = parkedLeftPx + actualRightWidth / 2;
      const maxCenterPx = Math.max(
        parkedCenterPx,
        labelsContainerWidth - unitPriceWidth - spacingXs - actualRightWidth / 2
      );
      let leftPx;
      let transform;
      if (tagCenterPx <= parkedCenterPx) {
        leftPx = parkedLeftPx;
        transform = 'none';
      } else if (tagCenterPx >= maxCenterPx) {
        leftPx = maxCenterPx;
        transform = 'translateX(-50%)';
      } else {
        leftPx = tagCenterPx;
        transform = 'translateX(-50%)';
      }
      const leftPct = labelsContainerWidth > 0 ? (leftPx / labelsContainerWidth) * 100 : 0;
      const maxLeftPct = transform === 'none'
        ? Math.max(0, ((labelsContainerWidth - actualRightWidth) / labelsContainerWidth) * 100)
        : 100;
      labelRightEl.style.left = `${Math.min(leftPct, maxLeftPct)}%`;
      labelRightEl.style.transform = transform;
      return;
    }

    const minRightPriceCenter = leftPriceWidth + spacingXs + actualRightWidth / 2;
    const maxRightPriceCenter = labelsContainerWidth - unitPriceWidth - spacingXs - actualRightWidth / 2;
    let rightPricePositionPercent;
    if (tagCenterPx <= minRightPriceCenter) {
      rightPricePositionPercent = (minRightPriceCenter / labelsContainerWidth) * 100;
    } else if (tagCenterPx >= maxRightPriceCenter) {
      rightPricePositionPercent = (maxRightPriceCenter / labelsContainerWidth) * 100;
    } else {
      rightPricePositionPercent = fillWidth;
    }
    labelRightEl.style.left = `${rightPricePositionPercent}%`;
    labelRightEl.style.transform = 'translateX(-50%)';
  },

  resetPriceBarCurrentLabel() {
    const bars = [
      this.inline?.querySelector('#buybox-2-price-bar'),
      this.popup?.querySelector('#buybox-2-popup-price-bar')
    ];
    bars.forEach((priceBar) => {
      const labelRightEl = priceBar?.querySelector(
        '#buybox-2-price-bar-label-right, #buybox-2-popup-price-bar-label-right'
      );
      if (!labelRightEl) return;
      labelRightEl.style.left = '';
      labelRightEl.style.transform = '';
    });
  },

  /**
   * Update price bar (shared logic for both Step 1 and Step 2)
   */
  updatePriceBarForElement(priceBar) {
    if (!priceBar) return;
    
    // Show price bar
    priceBar.style.display = 'block';
    
    const baseEl = priceBar.querySelector('#buybox-2-price-bar-base, #buybox-2-popup-price-bar-base');
    const baseUnitEl = priceBar.querySelector('#buybox-2-price-bar-base-unit, #buybox-2-popup-price-bar-base-unit');
    const labelLeftEl = priceBar.querySelector('.buybox-2-price-bar-label-left');
    const discountedValueEl = priceBar.querySelector('#buybox-2-price-bar-discounted-value, #buybox-2-popup-price-bar-discounted-value');
    const discountedUnitEl = priceBar.querySelector('#buybox-2-price-bar-discounted-unit, #buybox-2-popup-price-bar-discounted-unit');
    const discountEl = priceBar.querySelector('#buybox-2-price-bar-discount, #buybox-2-popup-price-bar-discount');
    const tagEl = priceBar.querySelector('#buybox-2-price-bar-tag, #buybox-2-popup-price-bar-tag');
    const fillEl = priceBar.querySelector('#buybox-2-price-bar-fill, #buybox-2-popup-price-bar-fill');
    const labelRightEl = priceBar.querySelector('#buybox-2-price-bar-label-right, #buybox-2-popup-price-bar-label-right');
    const labelUnitEl = priceBar.querySelector('#buybox-2-price-bar-label-unit, #buybox-2-popup-price-bar-label-unit');
    const unitValueEl = priceBar.querySelector('#buybox-2-price-bar-unit-value, #buybox-2-popup-price-bar-unit-value');
    const unitUnitEl = priceBar.querySelector('#buybox-2-price-bar-unit-unit, #buybox-2-popup-price-bar-unit-unit');
    
    if (!baseEl || !baseUnitEl || !labelLeftEl || !discountedValueEl || !discountedUnitEl || !discountEl || !tagEl || !fillEl || !labelRightEl || !labelUnitEl || !unitValueEl || !unitUnitEl) return;
    
    const basePrice = this.getBaseUnitPrice();
    const currentPrice = this.getCurrentUnitPrice();
    const minPrice = this.getMinimumUnitPrice();
    const possibleUnitPrice = this.getMinimumUnitPrice(); // Possible unit price with max discounts
    
    // Check total quantity to detect when quantity = 0
    const { flavors, selectedBulkOption } = this.state;
    let totalQuantity = 0;
    Object.values(flavors).forEach(flavor => {
      if (flavor.selected) {
        totalQuantity += flavor.quantity;
      }
    });
    totalQuantity = totalQuantity * selectedBulkOption;
    const hasNoQuantity = totalQuantity === 0;
    
    // Check if there's any discount
    const hasDiscount = currentPrice < basePrice && !hasNoQuantity;
    
    // Format base price
    baseEl.textContent = this.formatPrice(basePrice);
    
    // Always show and format possible unit price on the right (with max discounts)
    unitValueEl.textContent = this.formatPrice(possibleUnitPrice);
    labelUnitEl.style.display = 'block';
    
    // Hide middle price when current price is lower than or equal to possible price
    // Use a small epsilon for floating point comparison
    const epsilon = 0.01;
    const shouldHideMiddlePrice = currentPrice <= (possibleUnitPrice + epsilon) && !hasNoQuantity;
    
    // When at max discount, show unit annotation and apply success styling
    if (shouldHideMiddlePrice && hasDiscount) {
      unitUnitEl.textContent = this.getTranslation('buybox2.price_bar.unit', '/st');
      labelUnitEl.classList.add('buybox-2-price-bar-label-unit--max-discount');
    } else {
      unitUnitEl.textContent = '';
      labelUnitEl.classList.remove('buybox-2-price-bar-label-unit--max-discount');
    }
    
    // Handle no discount state (including when quantity = 0)
    if (!hasDiscount || hasNoQuantity) {
      // Hide right price, bar fill, and discount tag
      labelRightEl.style.display = 'none';
      fillEl.style.width = '0%';
      fillEl.style.display = 'none';
      tagEl.style.display = 'none';
      // Remove strikethrough from base price
      baseEl.classList.remove('buybox-2-price-bar-base--strikethrough');
      // Show "/bag" unit on left price
      baseUnitEl.textContent = this.getTranslation('buybox2.price_bar.unit', '/st');
      labelLeftEl.classList.add('buybox-2-price-bar-label-left--show-unit');
      // Unit price is already shown above, so we can return
      return;
    }
    
    // When there are discounts, hide the unit on left price
    baseUnitEl.textContent = '';
    labelLeftEl.classList.remove('buybox-2-price-bar-label-left--show-unit');
    
    // Hide middle price if current price reaches or exceeds possible price
    if (shouldHideMiddlePrice) {
      labelRightEl.style.display = 'none';
      // Also hide fill and tag when at max discount
      fillEl.style.width = '100%';
      tagEl.style.display = 'flex';
    } else {
      labelRightEl.style.display = 'flex';
    }
    
    // Show fill and discount tag (middle price visibility handled above)
    tagEl.style.display = 'flex';
    fillEl.style.display = 'block';
    
    // Format discounted price (split into value and unit)
    discountedValueEl.textContent = this.formatPrice(currentPrice);
    discountedUnitEl.textContent = this.getTranslation('buybox2.price_bar.unit', '/st');
    
    // Calculate discount percentage
    const discountPercent = basePrice > 0 ? Math.round(((basePrice - currentPrice) / basePrice) * 100) : 0;
    discountEl.textContent = `-${discountPercent}%`;
    
    // Calculate tag position (at the end of the green bar)
    const priceRange = basePrice - minPrice;
    const currentRange = basePrice - currentPrice;
    const fillWidth = priceRange > 0 ? (currentRange / priceRange) * 100 : 0;
    
    // Position tag at the end of the fill (transition point)
    tagEl.style.left = `${fillWidth}%`;
    // Ensure fill is visible and set width
    fillEl.style.display = 'block';
    fillEl.style.width = `${fillWidth}%`;
    
    // Force a reflow to ensure the fill is rendered
    void fillEl.offsetWidth;
    
    // Only calculate and position middle price if it's not hidden
    if (!shouldHideMiddlePrice) {
      this.positionPriceBarCurrentLabel(priceBar, {
        fillWidth,
        labelLeftEl,
        labelRightEl,
        discountedValueEl,
        discountedUnitEl
      });
    }
    
    // Add strikethrough to base price when there's a discount
    baseEl.classList.add('buybox-2-price-bar-base--strikethrough');
  },
  
  /**
   * Update both price bars (Step 1 and Step 2) - keeps them in sync
   */
  updatePriceBars() {
    // Update Step 1 price bar (inline)
    const step1PriceBar = this.inline?.querySelector('#buybox-2-price-bar');
    if (step1PriceBar) {
      this.updatePriceBarForElement(step1PriceBar);
    }
    
    // Update Step 2 price bar (popup)
    const step2PriceBar = this.popup?.querySelector('#buybox-2-popup-price-bar');
    if (step2PriceBar) {
      this.updatePriceBarForElement(step2PriceBar);
    }
  },
  
  /**
   * Update price bar (backwards compatibility - calls updatePriceBars)
   */
  updatePriceBar() {
    this.updatePriceBars();
  },
  
  /**
   * Update savings banner (in footer for step 1)
   */
  updateSavingsBanner() {
    const banner = this.footer?.querySelector('#buybox-2-savings-banner');
    if (!banner) return;
    
    const savings = this.state.totals.base - this.state.totals.final;
    
    if (savings <= 0) {
      banner.style.display = 'none';
      return;
    }
    
    banner.style.display = 'block';
    
    const amountText = this.getTranslation('buybox2.savings.amount', 'Je bespaart {amount}')
      .replace('{amount}', this.formatPrice(savings));
    
    const freeShippingText = this.getTranslation('buybox2.savings.free_shipping', '+ gratis verzending');
    
    let showFreeShipping = this.state.currencyCode === 'EUR' && this.state.totals.final >= 60;
    if (isBuybox2WizardOnetime()) {
      const threshold = Number(window.wizard2Flow?.stepHandler?.getWizard2ShippingMoneyForCountry?.()?.freeShippingThreshold);
      const cut = Number.isFinite(threshold) ? threshold : 70;
      showFreeShipping = this.state.totals.final >= cut;
    }
    
    banner.textContent = amountText + (showFreeShipping ? ` ${freeShippingText}` : '');
  },
  
  /**
   * Navigate to step
   */
  async navigateToStep(step) {
    const previousStep = this.state.currentStep;
    this.state.currentStep = step;
    
    // Determine transition direction
    const isForward = previousStep === 'flavors' && step === 'bulk';
    const isBackward = previousStep === 'bulk' && step === 'flavors';
    
    // Update back button visibility
    if (this.backButton) {
      this.backButton.style.display = step === 'bulk' ? 'block' : 'none';
    }
    
    // Build new content first (in temp container, then swap)
    // Start with content invisible for smooth fade-in
    // Apply direction-specific transition class
    if (isForward) {
      // Step 1 → 2: slide in from right
      this.content.classList.remove('buybox-2-content--transitioning-left');
      this.content.classList.add('buybox-2-content--transitioning-right');
    } else if (isBackward) {
      // Step 2 → 1: slide in from left
      this.content.classList.remove('buybox-2-content--transitioning-right');
      this.content.classList.add('buybox-2-content--transitioning-left');
    } else {
      // Default: use right transition
      this.content.classList.remove('buybox-2-content--transitioning-left');
      this.content.classList.add('buybox-2-content--transitioning-right');
    }
    
    // Build and swap content
    await this.renderContent();
    
    // Use requestAnimationFrame to ensure DOM is updated, then fade in
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        // Remove both transition classes to trigger fade-in
        this.content.classList.remove('buybox-2-content--transitioning-right', 'buybox-2-content--transitioning-left');
      });
    });
  },
  
  /**
   * Prefetch step 2 data in the background (non-blocking)
   * This ensures data is ready when user switches to step 2
   */
  prefetchStep2Data() {
    if (buybox2ShouldSkipStep2()) {
      return;
    }
    
    // Don't prefetch if already prefetching or if step 2 data is already loaded
    if (this._prefetchingStep2) {
      return;
    }
    
    // Only prefetch if we're on step 1
    if (this.state.currentStep !== 'flavors') {
      return;
    }
    
    this._prefetchingStep2 = true;
    
    // Prefetch in the background (non-blocking)
    Promise.all([
      // Ensure prices are loaded (should already be, but double-check)
      Object.keys(this.state.prices).length === 0 ? this.fetchPrices() : Promise.resolve()
    ]).catch(error => {
      // Silently handle errors - prefetch failures shouldn't break the UI
      this.Logger.warn('Step 2 prefetch failed (non-critical):', error);
    }).finally(() => {
      this._prefetchingStep2 = false;
    });
  },
  
  /**
   * Render Step 2: Bulk Options
   */
  async renderStep2() {
    const template = document.getElementById('buybox-2-step2-template');
    if (!template) {
      throw new Error('Step 2 template not found');
    }
    
    // Ensure default bulk option is selected (1x)
    if (!this.state.selectedBulkOption || this.state.selectedBulkOption < 1 || this.state.selectedBulkOption > 3) {
      this.state.selectedBulkOption = 1;
    }
    
    // Build step 2 content in a temporary container first (to avoid empty state)
    const tempContainer = document.createElement('div');
    tempContainer.appendChild(template.content.cloneNode(true));
    
    // Temporarily swap content reference so all methods work on temp container
    const originalContent = this.content;
    this.content = tempContainer;
    
    try {
      // No title/back button updates needed for popup (handled in HTML)
      
      // Render bulk options (works on temp container)
      await this.renderBulkOptions();
      
      // Restore original content reference
      this.content = originalContent;
      
      // Swap content in one operation (no empty state visible)
      // Content is already invisible due to transitioning class added in navigateToStep
      originalContent.replaceChildren(...Array.from(tempContainer.children));
      
      // Calculate pricing before updating price bar (ensures totals are current, not stale from localStorage)
      this.calculatePricing();
      
      // Update price bar now that content is swapped and pricing is calculated
      this.updatePriceBar();
      
      // Update footer (this will also setup the add to cart button)
      this.renderFooterStep2();
    } catch (error) {
      // Restore original content reference on error
      this.content = originalContent;
      throw error;
    }
  },
  
  /**
   * Render bulk options
   */
  async renderBulkOptions() {
    try {
      const container = this.content.querySelector('#buybox-2-bulk-options');
      if (!container) {
        this.Logger.error('Bulk options container not found');
        return;
      }
      
      const template = document.getElementById('buybox-2-bulk-option-template');
      if (!template) {
        this.Logger.error('Bulk option template not found');
        return;
      }
      
      container.innerHTML = '';
      
      // When base quantity < 3, hide daily period (rounding hides savings); default to week
      if (!this.isDailyPeriodAvailable() && this.state.pricePeriod === 'day') {
        this.state.pricePeriod = 'week';
        this.saveState();
      }
      
      // Calculate pricing for all multipliers without mutating state
      const multipliers = [1, 2, 3];
      const allPricing = {};
      multipliers.forEach(mult => {
        try {
          allPricing[mult] = this.calculatePricingForMultiplier(mult);
        } catch (error) {
          this.Logger.warn(`Error calculating pricing for multiplier ${mult}, using fallback:`, error);
          allPricing[mult] = { base: 0, final: 0 }; // Safe fallback
        }
      });
    
    // Render all options
    multipliers.forEach(multiplier => {
      try {
      const option = template.content.cloneNode(true);
      const optionElement = option.querySelector('.buybox-2-bulk-option-card');
      
      // Check if optionElement exists
      if (!optionElement) {
        this.Logger.error(`Failed to find bulk option card element for multiplier ${multiplier}`);
        return;
      }
      
      // Replace all MULTIPLIER placeholders in IDs and attributes
      // Get all elements including the optionElement itself
      const allElements = [optionElement, ...Array.from(option.querySelectorAll('*'))];
      allElements.forEach(el => {
        // Replace in id attribute
        if (el.id && el.id.includes('MULTIPLIER')) {
          el.id = el.id.replace(/MULTIPLIER/g, multiplier);
        }
        // Replace in for attribute
        if (el.hasAttribute('for') && el.getAttribute('for').includes('MULTIPLIER')) {
          el.setAttribute('for', el.getAttribute('for').replace(/MULTIPLIER/g, multiplier));
        }
        // Replace in data-multiplier attribute
        if (el.hasAttribute('data-multiplier') && el.getAttribute('data-multiplier') === 'MULTIPLIER') {
          el.setAttribute('data-multiplier', multiplier);
        }
        // Replace in value attribute
        if (el.hasAttribute('value') && el.getAttribute('value') === 'MULTIPLIER') {
          el.setAttribute('value', multiplier);
        }
      });
      
      // Set multiplier on card element
      optionElement.setAttribute('data-multiplier', multiplier);
      const radio = optionElement.querySelector('input[type="radio"]');
      if (radio) {
        radio.value = multiplier;
        radio.id = `buybox-2-bulk-${multiplier}`;
        // Set checked state based on selectedBulkOption (will be set correctly after all options are rendered)
        radio.checked = this.state.selectedBulkOption === multiplier;
      }
      
      // Update label for attribute
      const label = optionElement.querySelector('.buybox-2-bulk-option-label');
      if (label) {
        label.setAttribute('for', `buybox-2-bulk-${multiplier}`);
      }
      
      // Update title with dynamic frequency or stock option
      const titleEl = optionElement.querySelector('.buybox-2-bulk-option-title');
      if (titleEl) {
        if (this.state.deliveryMode === 'onetime') {
          // For one-time orders, show stock option labels
          const optionKey = `buybox2.step2.option_${multiplier}x`;
          const optionText = this.getTranslation(optionKey, `Option ${multiplier}x`);
          titleEl.textContent = optionText;
        } else {
          // For subscriptions: always use weekly format to match Step 1 frequency selector
          const baseDays = parseInt(this.state.sellingPlan) || 28;
          const frequencyDays = baseDays * multiplier;
          titleEl.textContent = this.formatSellingPlanInWeeks(frequencyDays);
        }
      }
      
      // Update badge
      const badgeEl = optionElement.querySelector(`#buybox-2-bulk-badge-${multiplier}`);
      if (badgeEl) {
        if (multiplier === 2) {
          const badgeIcon = badgeEl.querySelector('.buybox-2-bulk-badge-icon');
          const badgeText = badgeEl.querySelector('.buybox-2-bulk-badge-text');
          if (badgeIcon) badgeIcon.textContent = '⭐';
          if (badgeText) badgeText.textContent = this.getTranslation('buybox2.step2.badge_populairst', 'POPULAIRST');
          badgeEl.classList.add('buybox-2-bulk-badge-popular');
          badgeEl.style.display = 'flex';
        } else if (multiplier === 3) {
          const badgeIcon = badgeEl.querySelector('.buybox-2-bulk-badge-icon');
          const badgeText = badgeEl.querySelector('.buybox-2-bulk-badge-text');
          if (badgeIcon) badgeIcon.textContent = '🤝';
          if (badgeText) badgeText.textContent = this.getTranslation('buybox2.step2.badge_beste_deal', 'BESTE DEAL');
          badgeEl.classList.add('buybox-2-bulk-badge-best-deal');
          badgeEl.style.display = 'flex';
        } else {
          badgeEl.style.display = 'none';
        }
      }
      
      // Update quantities text (first benefit)
      const quantitiesEl = optionElement.querySelector(`#buybox-2-bulk-quantities-${multiplier}`);
      if (quantitiesEl) {
        const { flavors } = this.state;
        const quantities = [];
        FlavorDistribution.forEachFlavorKeyInOrder(flavors, (key, flavor) => {
          if (flavor.selected) {
            const flavorNames = {
              rund: this.getTranslation('buybox2.step1.flavor_rund', 'Rund'),
              kip: this.getTranslation('buybox2.step1.flavor_kip', 'Kip'),
              vis: this.getTranslation('buybox2.step1.flavor_vis', 'Vis')
            };
            quantities.push(`${flavor.quantity * multiplier}x ${flavorNames[key]}`);
          }
        });
        
        const quantitiesText = quantities.join(', ');
        quantitiesEl.textContent = quantitiesText;
      }
      
      // Update delivery benefit (second benefit)
      const deliveryBenefitEl = optionElement.querySelector(`#buybox-2-bulk-delivery-benefit-${multiplier}`);
      if (deliveryBenefitEl) {
        const deliveryText = deliveryBenefitEl.querySelector('.buybox-2-bulk-benefit-text');
        if (deliveryText) {
          if (multiplier === 1) {
            deliveryText.textContent = this.getTranslation('buybox2.step2.benefit_fast_delivery', 'Probeer klein');
            deliveryBenefitEl.style.display = 'flex';
          } else if (multiplier === 2) {
            deliveryText.textContent = this.getTranslation('buybox2.step2.benefit_less_mail', 'Minder leveringen');
            deliveryBenefitEl.style.display = 'flex';
          } else if (multiplier === 3) {
            deliveryText.textContent = this.getTranslation('buybox2.step2.benefit_least_mail', 'Minste aantal leveringen');
            deliveryBenefitEl.style.display = 'flex';
          } else {
            deliveryBenefitEl.style.display = 'none';
          }
        }
      }
      
      // Update sustainability (third benefit)
      const sustainabilityEl = optionElement.querySelector(`#buybox-2-bulk-sustainability-${multiplier}`);
      if (sustainabilityEl) {
        const sustainabilityIcon = sustainabilityEl.querySelector('.buybox-2-bulk-sustainability-icon');
        const sustainabilityText = sustainabilityEl.querySelector('.buybox-2-bulk-benefit-text');
        if (multiplier === 2) {
          if (sustainabilityIcon) sustainabilityIcon.textContent = '🌱';
          if (sustainabilityText) sustainabilityText.textContent = this.getTranslation('buybox2.step2.sustainability_2x', 'Duurzamer');
          sustainabilityEl.style.display = 'flex';
        } else if (multiplier === 3) {
          if (sustainabilityIcon) sustainabilityIcon.textContent = '🌍';
          if (sustainabilityText) sustainabilityText.textContent = this.getTranslation('buybox2.step2.sustainability_3x', 'Duurzaamst');
          sustainabilityEl.style.display = 'flex';
        } else {
          sustainabilityEl.style.display = 'none';
        }
      }
      
      // Append the DocumentFragment first (moves children to container)
      container.appendChild(option);
      
      // Update pricing display using pre-calculated totals (no state mutation)
      try {
        this.updateBulkOptionPricingDisplay(optionElement, multiplier, allPricing[multiplier], allPricing[1]);
      } catch (pricingError) {
        this.Logger.error(`Error updating pricing for bulk option ${multiplier}:`, pricingError);
        // Continue even if pricing fails
      }
      
      // Setup stock calculator for one-time mode (1x only)
      if (multiplier === 1 && this.state.deliveryMode === 'onetime') {
        const stockCalcEl = optionElement.querySelector(`#buybox-2-bulk-stock-${multiplier}`);
        if (stockCalcEl) {
          stockCalcEl.style.display = 'flex';
          this.renderBulkStockCalculator(stockCalcEl.querySelector(`#buybox-2-bulk-stock-content-${multiplier}`));
          
          // Add class to price row to adjust layout (remove gap, place stock calculator next to dropdown)
          const priceRow = optionElement.querySelector('.buybox-2-bulk-option-price-row');
          if (priceRow) {
            priceRow.classList.add('buybox-2-bulk-option-price-row--with-stock');
          }
        }
      }
      
      // Setup price period selector - ensure it uses the restored state value
      const periodSelect = optionElement.querySelector(`#buybox-2-bulk-period-${multiplier}`);
      if (periodSelect) {
        // When base quantity < 3, hide daily option (only week + box)
        if (!this.isDailyPeriodAvailable()) {
          const dayOption = periodSelect.querySelector('option[value="day"]');
          if (dayOption) dayOption.remove();
        }
        const savedPricePeriod = this.isDailyPeriodAvailable()
          ? (this.state.pricePeriod || 'day')
          : 'week';
        periodSelect.value = savedPricePeriod;
      }
      
      this.Logger.log(`Successfully rendered bulk option ${multiplier}`);
      } catch (error) {
        this.Logger.error(`Error rendering bulk option ${multiplier}:`, error);
        // Continue with next option instead of breaking the entire render
      }
      });
      
      // Set up event listeners once using event delegation (after all options are rendered)
      try {
        this.setupBulkOptionEventListeners(container);
      } catch (error) {
        this.Logger.warn('Error setting up bulk option event listeners:', error);
        // Continue even if event listeners fail
      }
      
      // Restore dropdown values after event listeners are set up (cloning resets them)
      const finalContainer = this.content.querySelector('#buybox-2-bulk-options');
      if (finalContainer) {
        const savedPricePeriod = this.isDailyPeriodAvailable()
          ? (this.state.pricePeriod || 'day')
          : 'week';
        const allPeriodSelectors = finalContainer.querySelectorAll('.buybox-2-bulk-price-period-selector');
        allPeriodSelectors.forEach(selector => {
          selector.value = savedPricePeriod;
        });
      }
      
      // Ensure radio checked state is correct (after all options are rendered)
      try {
        this.updateBulkOptionSelection();
      } catch (error) {
        this.Logger.warn('Error updating bulk option selection:', error);
        // Continue even if selection update fails
      }
      } catch (error) {
        // Never throw - log and continue without bulk options
        this.Logger.error('Error in renderBulkOptions, continuing without bulk options:', error);
        // Don't throw - let the modal continue rendering
      }
  },
  
  /**
   * Update bulk option pricing display (does not mutate state)
   * @param {HTMLElement} optionElement - The bulk option card element
   * @param {number} multiplier - The multiplier (1, 2, or 3)
   * @param {Object} totals - Pre-calculated totals for this multiplier { base, final }
   * @param {Object} baseTotals - Pre-calculated totals for 1x multiplier { base, final }
   */
  updateBulkOptionPricingDisplay(optionElement, multiplier, totals, baseTotals) {
    const { deliveryMode } = this.state;
    // Use week when daily is hidden (base quantity < 3)
    const pricePeriod = (this.state.pricePeriod === 'day' && !this.isDailyPeriodAvailable())
      ? 'week'
      : (this.state.pricePeriod || 'day');
    
    // Calculate price per period
    let pricePerPeriod = 0;
    let comparePricePerPeriod = 0;
    
    if (deliveryMode === 'subscription') {
      const baseDays = parseInt(this.state.sellingPlan) || 28;
      const totalDays = baseDays * multiplier;
      
      if (pricePeriod === 'day') {
        pricePerPeriod = totals.final / totalDays;
        comparePricePerPeriod = totals.base / totalDays;
      } else if (pricePeriod === 'week') {
        pricePerPeriod = (totals.final / totalDays) * 7;
        comparePricePerPeriod = (totals.base / totalDays) * 7;
      } else if (pricePeriod === 'box') {
        pricePerPeriod = totals.final;
        comparePricePerPeriod = totals.base;
      }
    } else {
      // One-time mode: use stock calculator days
      const expectedDays = this.calculateExpectedDays(multiplier);
      
      // Validate expectedDays to prevent division by zero or invalid calculations
      if (!isFinite(expectedDays) || expectedDays <= 0) {
        this.Logger.warn(`Invalid expectedDays (${expectedDays}) for multiplier ${multiplier}, using fallback`);
        // Fallback: use a safe default (30 days)
        const fallbackDays = 30;
        if (pricePeriod === 'day') {
          pricePerPeriod = totals.final / fallbackDays;
          comparePricePerPeriod = totals.base / fallbackDays;
        } else if (pricePeriod === 'week') {
          pricePerPeriod = (totals.final / fallbackDays) * 7;
          comparePricePerPeriod = (totals.base / fallbackDays) * 7;
        } else if (pricePeriod === 'box') {
          pricePerPeriod = totals.final;
          comparePricePerPeriod = totals.base;
        }
      } else {
        if (pricePeriod === 'day') {
          pricePerPeriod = totals.final / expectedDays;
          comparePricePerPeriod = totals.base / expectedDays;
        } else if (pricePeriod === 'week') {
          pricePerPeriod = (totals.final / expectedDays) * 7;
          comparePricePerPeriod = (totals.base / expectedDays) * 7;
        } else if (pricePeriod === 'box') {
          pricePerPeriod = totals.final;
          comparePricePerPeriod = totals.base;
        }
      }
    }
    
    // Update price displays
    const currentPriceEl = optionElement.querySelector(`#buybox-2-bulk-price-current-${multiplier}`);
    const comparePriceEl = optionElement.querySelector(`#buybox-2-bulk-price-compare-${multiplier}`);
    const bulkPriceEl = optionElement.querySelector(`#buybox-2-bulk-price-bulk-${multiplier}`);
    const savingsEl = optionElement.querySelector(`#buybox-2-bulk-savings-${multiplier}`);
    
    const periodLabel = this.getTranslation(`buybox2.price_period.${pricePeriod}`, pricePeriod);
    
    if (multiplier === 1) {
      // 1x: Show single price only (no compare price for box period)
      if (currentPriceEl) {
        currentPriceEl.textContent = this.formatPrice(pricePerPeriod);
        currentPriceEl.style.color = 'var(--type-color-800)';
        currentPriceEl.style.textDecoration = '';
      }
      // Never show compare price for 1x
      if (comparePriceEl) comparePriceEl.style.display = 'none';
      if (bulkPriceEl) bulkPriceEl.style.display = 'none';
    } else {
      // 2x/3x: Show 1x price (strikethrough) + bulk price (green)
      // Compare price MUST always match the 1x option so users can compare savings
      let subscriptionPricePerPeriod = 0;
      let dailySubscriptionPrice = 0;
      let dailyBulkPrice = 0;
      
      // Compute 1x price for this period (used as strikethrough compare for 2x/3x)
      if (deliveryMode === 'subscription') {
        const baseDays = parseInt(this.state.sellingPlan) || 28;
        const days1x = baseDays;
        subscriptionPricePerPeriod = pricePeriod === 'day'
          ? baseTotals.final / days1x
          : pricePeriod === 'week'
            ? (baseTotals.final / days1x) * 7
            : baseTotals.final;
        dailySubscriptionPrice = baseTotals.final / days1x;
        dailyBulkPrice = totals.final / (baseDays * multiplier);
      } else {
        const expectedDays1x = this.calculateExpectedDays(1);
        if (!isFinite(expectedDays1x) || expectedDays1x <= 0) {
          const fallbackDays = 30;
          subscriptionPricePerPeriod = pricePeriod === 'day'
            ? baseTotals.final / fallbackDays
            : pricePeriod === 'week'
              ? (baseTotals.final / fallbackDays) * 7
              : baseTotals.final;
          dailySubscriptionPrice = baseTotals.final / fallbackDays;
          dailyBulkPrice = totals.final / (this.calculateExpectedDays(multiplier) || fallbackDays);
        } else {
          subscriptionPricePerPeriod = pricePeriod === 'day'
            ? baseTotals.final / expectedDays1x
            : pricePeriod === 'week'
              ? (baseTotals.final / expectedDays1x) * 7
              : baseTotals.final;
          dailySubscriptionPrice = baseTotals.final / expectedDays1x;
          dailyBulkPrice = totals.final / this.calculateExpectedDays(multiplier);
        }
      }
      
      // Validate subscription price
      if (!isFinite(subscriptionPricePerPeriod) || subscriptionPricePerPeriod < 0) {
        this.Logger.warn(`Invalid subscriptionPricePerPeriod (${subscriptionPricePerPeriod}) for multiplier ${multiplier}, using fallback`);
        subscriptionPricePerPeriod = 0;
      }
      
      // Validate subscription price
      if (!isFinite(subscriptionPricePerPeriod) || subscriptionPricePerPeriod < 0) {
        this.Logger.warn(`Invalid subscriptionPricePerPeriod (${subscriptionPricePerPeriod}) for multiplier ${multiplier}, using fallback`);
        subscriptionPricePerPeriod = 0;
      }
      
      // For box period: show 1x price (strikethrough) and bulk price
      // For day/week periods: show 1x price (strikethrough) and bulk price
      if (pricePeriod === 'box') {
        // Box period: show 1x price (strikethrough) and bulk price
        if (currentPriceEl) {
          currentPriceEl.textContent = this.formatPrice(subscriptionPricePerPeriod);
          currentPriceEl.style.color = 'var(--type-color-800)';
          currentPriceEl.style.textDecoration = 'line-through';
          currentPriceEl.style.display = 'inline';
        }
        
        // Show bulk price (green, no strikethrough)
        if (bulkPriceEl) {
          bulkPriceEl.textContent = this.formatPrice(pricePerPeriod);
          bulkPriceEl.style.color = 'var(--color-status-success)';
          bulkPriceEl.style.textDecoration = 'none';
          bulkPriceEl.style.display = 'inline';
        }
        
        // Never show comparePriceEl (leftmost gray price)
        if (comparePriceEl) comparePriceEl.style.display = 'none';
      } else {
        // Day/week periods: show subscription price (strikethrough, charcoal) and bulk price (green)
        if (currentPriceEl) {
          currentPriceEl.textContent = this.formatPrice(subscriptionPricePerPeriod);
          currentPriceEl.style.color = 'var(--type-color-800)';
          currentPriceEl.style.textDecoration = 'line-through';
          currentPriceEl.style.display = 'inline';
        }
        
        // Show bulk price (green, no strikethrough)
        if (bulkPriceEl) {
          bulkPriceEl.textContent = this.formatPrice(pricePerPeriod);
          bulkPriceEl.style.color = 'var(--color-status-success)';
          bulkPriceEl.style.textDecoration = 'none';
          bulkPriceEl.style.display = 'inline';
        }
        
        // Never show comparePriceEl
        if (comparePriceEl) comparePriceEl.style.display = 'none';
      }
      
      // Calculate and show annual savings for 2x and 3x
      // Always use daily prices for annual savings calculation, regardless of selected period
      if (savingsEl) {
        const dailySavings = dailySubscriptionPrice - dailyBulkPrice;
        const annualSavings = dailySavings * 365;
        const savingsText = this.getTranslation('buybox2.step2.annual_savings', 'Je bespaart {amount} per jaar')
          .replace('{amount}', this.formatPrice(annualSavings));
        savingsEl.textContent = savingsText;
        savingsEl.style.display = 'block';
      }
    }
    
    if (multiplier === 1 && savingsEl) {
      savingsEl.style.display = 'none';
    }
  },
  
  /**
   * Set up event listeners for bulk options (using event delegation)
   */
  setupBulkOptionEventListeners(container) {
    // Remove old listeners by cloning the container
    const newContainer = container.cloneNode(true);
    container.parentNode.replaceChild(newContainer, container);
    
    // Radio change listener (event delegation)
    newContainer.addEventListener('change', (e) => {
      if (e.target.type === 'radio' && e.target.name === 'bulk-option') {
        const multiplier = parseInt(e.target.value);
        if (e.target.checked) {
          this.state.selectedBulkOption = multiplier;
          this.trackEvent('buybox-2_bulk_selected', { multiplier });
          // Update state totals for selected option
          this.state.totals = this.calculatePricingForMultiplier(multiplier);
          this.updateAll();
          // Always update add to cart button and savings banner when bulk option changes (regardless of currentStep)
          // This ensures they update correctly even if currentStep was restored to 'flavors'
          this.updateAddToCartButton();
          this.updateSavingsBannerStep2();
        }
      }
    });
    
    // Price period selector change listener (event delegation)
    newContainer.addEventListener('change', (e) => {
      if (e.target.classList.contains('buybox-2-bulk-price-period-selector')) {
        this.state.pricePeriod = e.target.value;
        this.saveState();
        
        // Update all three dropdowns to show the same selected value
        const allPeriodSelectors = newContainer.querySelectorAll('.buybox-2-bulk-price-period-selector');
        allPeriodSelectors.forEach(selector => {
          selector.value = this.state.pricePeriod;
        });
        
        // Update all pricing displays without re-rendering
        this.updateAllBulkOptionPricing();
        this.updateAll();
      }
    });
    
    // Stock calculator change listener (event delegation)
    newContainer.addEventListener('change', (e) => {
      const target = e.target;
      if (target.id === 'buybox-2-bulk-dog-count') {
        const value = parseInt(target.value) || 1;
        const clampedCount = Math.max(1, Math.min(10, value));
        this.state.dogCount = clampedCount;
        this.ensureDogWeights();
        this.saveState();
        // Re-render bulk calculator (number of weight selects changed)
        const bulkContent = this.popupContent?.querySelector('#buybox-2-bulk-stock-content-1') || this.content?.querySelector('#buybox-2-bulk-stock-content-1');
        if (bulkContent) this.renderBulkStockCalculator(bulkContent);
        this.updateBulkStockNoticeDays();
        this.updateStockNotice();
        this.updateStockNoticeDays();
        this.updateAllBulkOptionPricing();
        this.updateAll();
      } else {
        const weightMatch = target.id && target.id.match(/^buybox-2-bulk-dog-weight-(\d+)$/);
        if (weightMatch) {
          const index = parseInt(weightMatch[1], 10) - 1;
          const value = parseInt(target.value) || 18;
          const clampedValue = Math.max(1, Math.min(100, value));
          this.ensureDogWeights();
          if (this.state.dogWeights[index] !== undefined) {
            this.state.dogWeights[index] = clampedValue;
          }
          this.saveState();
          this.updateBulkStockNoticeDays();
          this.updateStockNoticeDays();
          this.updateAllBulkOptionPricing();
          this.updateAll();
        }
      }
    });
  },
  
  /**
   * Update bulk option selection (ensure radio checked state matches selectedBulkOption)
   */
  updateBulkOptionSelection() {
    // Check popupContent first (Step 2 popup), then content (Step 1 inline)
    const container = this.popupContent?.querySelector('#buybox-2-bulk-options') || this.content?.querySelector('#buybox-2-bulk-options');
    if (!container) return;
    
    const radios = container.querySelectorAll('input[type="radio"][name="bulk-option"]');
    radios.forEach(radio => {
      const multiplier = parseInt(radio.value);
      radio.checked = this.state.selectedBulkOption === multiplier;
    });
  },
  
  /**
   * Render bulk stock calculator (for one-time mode, 1x only)
   * Uses inline sentence style: "for [dogCount] dogs of [w1], [w2] & [w3] kg"
   */
  renderBulkStockCalculator(container) {
    if (!container) return;
    
    this.ensureDogWeights();
    const { dogCount } = this.state;
    const dogWord = this.getPluralizedText(dogCount, 'dog_singular', 'dog_plural');
    
    // Create dog count select (max 10)
    let dogCountOptions = '';
    for (let i = 1; i <= 10; i++) {
      dogCountOptions += `<option value="${i}" ${i === dogCount ? 'selected' : ''}>${i}</option>`;
    }
    
    const dogWeightsHTML = this.buildDogWeightsSelectsHTML('buybox-2-bulk');
    
    const translations = window.BuyboxTranslations2 || {};
    let stockText = translations['buybox2.step2.bulk_stock_calculator_text'] || 'for {dogCount} {dogWord} of {dogWeight} kg';
    
    stockText = stockText
      .replace(/{dogCount}/g, `<select id="buybox-2-bulk-dog-count" class="buybox-2-stock-notice-select">${dogCountOptions}</select>`)
      .replace(/{dogWord}/g, `<span class="buybox-2-stock-notice-dog-word">${dogWord}</span>`)
      .replace(/{dogWeight}/g, dogWeightsHTML);
    
    container.innerHTML = stockText;
  },
  
  /**
   * Update bulk stock notice: pluralization and select values
   */
  updateBulkStockNoticeDays() {
    const stockCalcEl = this.popupContent?.querySelector('#buybox-2-bulk-stock-1') || this.content?.querySelector('#buybox-2-bulk-stock-1');
    if (!stockCalcEl || stockCalcEl.style.display === 'none') return;
    
    const stockNoticeContent = stockCalcEl.querySelector('#buybox-2-bulk-stock-content-1');
    if (!stockNoticeContent) return;
    
    this.ensureDogWeights();
    const { dogWeights, dogCount } = this.state;
    
    const dogWord = this.getPluralizedText(dogCount, 'dog_singular', 'dog_plural');
    const dogWordSpan = stockNoticeContent.querySelector('.buybox-2-stock-notice-dog-word');
    if (dogWordSpan) dogWordSpan.textContent = dogWord;
    
    const dogCountSelect = stockNoticeContent.querySelector('#buybox-2-bulk-dog-count');
    if (dogCountSelect && dogCountSelect.value !== String(dogCount)) {
      dogCountSelect.value = String(dogCount);
    }
    
    dogWeights.forEach((w, i) => {
      const sel = stockNoticeContent.querySelector(`#buybox-2-bulk-dog-weight-${i + 1}`);
      const rounded = Math.max(1, Math.min(100, Math.round(w) || 18));
      if (sel && sel.value !== String(rounded)) {
        sel.value = String(rounded);
      }
    });
  },
  
  
  /**
   * Process cart addition (shared by button and auto-add on close)
   */
  async processCartAddition() {
    // Import cart handler
    if (typeof Buybox2CartHandler === 'undefined') {
      throw new Error('Cart handler not loaded');
    }
    
    // Validate selling plans mapping is loaded (critical for subscription mode)
    if (this.state.deliveryMode === 'subscription') {
      // Check if mapping is null/undefined OR empty object
      const isMappingEmpty = !this.sellingPlansMapping || Object.keys(this.sellingPlansMapping).length === 0;
      
      if (isMappingEmpty) {
        const errorMsg = 'Selling plans configuration not loaded. Please refresh the page and try again.';
        this.Logger.error(errorMsg, {
          sellingPlansMapping: this.sellingPlansMapping,
          isNull: !this.sellingPlansMapping,
          isEmpty: this.sellingPlansMapping && Object.keys(this.sellingPlansMapping).length === 0
        });
        throw new Error(errorMsg);
      }
      
      // Validate selling plan is set
      const baseDays = parseInt(this.state.sellingPlan);
      if (!baseDays || (baseDays !== 28 && baseDays !== 56 && baseDays !== 84)) {
        this.Logger.warn(`Invalid sellingPlan in state: ${this.state.sellingPlan}. Defaulting to 28 days.`);
        this.state.sellingPlan = '28';
      }
      
      // Pre-validate that selling plan ID exists for the selected configuration
      const totalDays = parseInt(this.state.sellingPlan) * this.state.selectedBulkOption;
      const testSellingPlanId = this.getSellingPlanId(totalDays);
      if (!testSellingPlanId) {
        const errorMsg = `Selling plan not found for ${totalDays} days (base: ${this.state.sellingPlan}, bulk: ${this.state.selectedBulkOption}). Please refresh the page.`;
        this.Logger.error(errorMsg, {
          totalDays,
          baseDays: this.state.sellingPlan,
          bulkOption: this.state.selectedBulkOption,
          mappingKeys: Object.keys(this.sellingPlansMapping).slice(0, 10)
        });
        throw new Error(errorMsg);
      }
      
      this.Logger.log(`Cart addition validated: sellingPlan=${this.state.sellingPlan}, bulkOption=${this.state.selectedBulkOption}, totalDays=${totalDays}, sellingPlanId=${testSellingPlanId}`);
    }
    
    // Add to cart (using JSON format like preorder-modal-3)
    const success = await Buybox2CartHandler.processCartAddition(
      this.state,
      this.PRODUCT,
      this.getSellingPlanId.bind(this),
      {
        digitalSellingPlanId: this.freebieSellingPlanId,
        guideVariantId: this.freebieGuideVariantId,
        scoopVariantId: this.freebieScoopVariantId,
        rewardsOn:
          typeof window.bzRewardsExperimentOn === 'function'
            ? window.bzRewardsExperimentOn()
            : false
      }
    );
    
    if (!success) {
      throw new Error('Cart addition failed');
    }
    
    // Track success
    this.trackEvent('buybox-2_cart_success');
    
    // Clear state
    this.clearState();
    
    return true;
  },
  
  /**
   * Setup add to cart button
   */
  setupAddToCartButton() {
    const button = this.popupFooter?.querySelector('#buybox-2-add-to-cart') || this.popupContent?.querySelector('#buybox-2-add-to-cart');
    if (!button) return;
    
    button.addEventListener('click', async () => {
      if (button.disabled) return;
      
      // Store original button content (just the label now)
      const label = button.querySelector('#buybox-2-add-to-cart-label');
      const originalText = label?.textContent || '';
      
      button.disabled = true;
      button.classList.add('loading');
      
      // Replace button text with loading text
      const loadingText = this.getTranslation('buybox2.step2.adding', 'Adding...');
      if (label) {
        label.textContent = loadingText;
      }
      
      try {
        // Process cart addition
        await this.processCartAddition();
        
        // Mark as added (prevent duplicate on close)
        this._cartAdded = true;
        
        // Close popup
        this._actuallyClosePopup();
        
        // Trigger cart drawer
        await this.triggerCartDrawer();
        
      } catch (error) {
        // Always log to console for debugging
        this.Logger.error('Failed to add to cart', error);
        
        // Track failure
        this.trackEvent('buybox-2_cart_failure', {
          error: error.message
        });
        
        // Restore original button text
        if (label) {
          label.textContent = originalText;
        }
        
        // Always re-enable button, even if there was an error
        button.disabled = false;
        button.classList.remove('loading');
        
        // Show user-friendly error message
        alert(error.message || 'Er is een fout opgetreden bij het toevoegen aan de winkelwagen. Probeer het opnieuw.');
      }
    });
    
    // Update button state
    this.updateAddToCartButton();
  },
  
  /**
   * Update add to cart button
   */
  updateAddToCartButton() {
    // Check popupFooter first (Step 2 popup), then footer (Step 1 inline), then content
    const button = this.popupFooter?.querySelector('#buybox-2-add-to-cart') || this.footer?.querySelector('#buybox-2-add-to-cart') || this.content?.querySelector('#buybox-2-add-to-cart');
    const label = button?.querySelector('#buybox-2-add-to-cart-label');
    const compareEl = button?.querySelector('#buybox-2-add-to-cart-compare');
    const finalEl = button?.querySelector('#buybox-2-add-to-cart-final');
    
    if (!button || !label) return;
    
    // Update text based on selected bulk option (1x vs 2x/3x)
    const { selectedBulkOption } = this.state;
    if (selectedBulkOption === 1) {
      label.textContent = this.getTranslation('buybox2.step2.button_1x', 'Add');
    } else {
      label.textContent = this.getTranslation('buybox2.step2.button_bulk', 'Add bulk and save');
    }
    
    // Update pricing (matching buybox-1 logic)
    if (finalEl) {
      const selectedTotals = this.calculatePricingForMultiplier(selectedBulkOption);
      const hasTotals = selectedTotals.final > 0 || selectedTotals.base > 0;

      if (hasTotals) {
        const compareTotal = selectedTotals.base;
        const finalTotal = selectedTotals.final;

        finalEl.textContent = this.formatPrice(finalTotal);

        if (compareEl) {
          if (compareTotal === finalTotal) {
            compareEl.style.display = 'none';
          } else {
            compareEl.style.display = 'inline';
            compareEl.textContent = this.formatPrice(compareTotal);
          }
        }
      }
    }
  },
  
  /**
   * Render footer for step 1
   */
  renderFooterStep1() {
    const template = document.getElementById('buybox-2-footer-step1-template');
    if (!template || !this.footer) return;
    
    // Clear footer and append cloned template (DocumentFragment can't be assigned to innerHTML)
    this.footer.innerHTML = '';
    this.footer.appendChild(template.content.cloneNode(true));
    
    // Setup continue button (will be called again, but ensures it's set up)
    this.setupContinueButton();
  },
  
  /**
   * Render footer for step 2
   */
  renderFooterStep2() {
    const template = document.getElementById('buybox-2-footer-step2-template');
    // Use popupFooter if available (Step 2 popup), otherwise use footer (Step 1 inline)
    const footer = this.popupFooter || this.footer;
    if (!template || !footer) return;
    
    // Clear footer and append cloned template (DocumentFragment can't be assigned to innerHTML)
    footer.innerHTML = '';
    footer.appendChild(template.content.cloneNode(true));
    
    // Setup add to cart button
    this.setupAddToCartButton();
    
    // Explicitly update button text based on selected bulk option (setupAddToCartButton calls this, but ensure it's updated)
    this.updateAddToCartButton();
    
    // Update savings banner in footer
    this.updateSavingsBannerStep2();
  },
  
  /**
   * Update savings banner in step 2 footer
   */
  updateSavingsBannerStep2() {
    // Use popupFooter if available (Step 2 popup), otherwise use footer (Step 1 inline)
    const footer = this.popupFooter || this.footer;
    const banner = footer?.querySelector('#buybox-2-savings-banner-step2');
    if (!banner) return;
    
    const savings = this.state.totals.base - this.state.totals.final;
    
    if (savings <= 0) {
      banner.style.display = 'none';
      return;
    }
    
    banner.style.display = 'block';
    
    const amountText = this.getTranslation('buybox2.savings.amount', 'Je bespaart {amount}')
      .replace('{amount}', this.formatPrice(savings));
    
    const freeShippingText = this.getTranslation('buybox2.savings.free_shipping', '+ gratis verzending');
    
    const showFreeShipping = this.state.currencyCode === 'EUR' && this.state.totals.final >= 60;
    
    banner.textContent = amountText + (showFreeShipping ? ` ${freeShippingText}` : '');
  },
  
  /**
   * Update all UI elements
   */
  updateAll() {
    if (isBuybox2WizardOnetime()) {
      this.state.deliveryMode = 'onetime';
      this.state.selectedBulkOption = 1;
    }
    // Update state totals for currently selected bulk option
    this.state.totals = this.calculatePricingForMultiplier(this.state.selectedBulkOption);
    this.updatePricingDisplay();
    this.saveState();
    
    if (this.state.currentStep === 'flavors') {
      this.updatePriceBars(); // Update both Step 1 and Step 2 price bars
      this.updateSavingsBanner();
      this.updateContinueButton();
      this.updatePackageSummary(this.inline?.querySelector('#buybox-2-package-summary'));
      // Update stock calculator when quantities change
      this.updateStockNotice();
      this.updateStockNoticeDays();
      if (isBuybox2WizardOnetime() && typeof buybox2WizardOnetime().onUpdate === 'function') {
        buybox2WizardOnetime().onUpdate(this);
      }
    } else if (this.state.currentStep === 'bulk') {
      // Update bulk option pricing displays without re-rendering
      this.updateAllBulkOptionPricing();
      this.updatePriceBars(); // Update both Step 1 and Step 2 price bars
      this.updateAddToCartButton();
      this.updateSavingsBannerStep2();
      this.updateBulkOptionSelection();
      // Update bulk stock calculator days if visible
      this.updateBulkStockNoticeDays();
    }

    this.updateRewardsPunchCard();
  },
  
  /**
   * Update all bulk option pricing displays (without re-rendering)
   */
  updateAllBulkOptionPricing() {
    // Check popupContent first (Step 2 popup), then content (Step 1 inline)
    const container = this.popupContent?.querySelector('#buybox-2-bulk-options') || this.content?.querySelector('#buybox-2-bulk-options');
    if (!container) return;
    
    // Calculate pricing for all multipliers
    const multipliers = [1, 2, 3];
    const allPricing = {};
    multipliers.forEach(mult => {
      allPricing[mult] = this.calculatePricingForMultiplier(mult);
    });
    
    // Update each option's pricing display
    multipliers.forEach(multiplier => {
      const optionElement = container.querySelector(`[data-multiplier="${multiplier}"]`);
      if (optionElement) {
        this.updateBulkOptionPricingDisplay(optionElement, multiplier, allPricing[multiplier], allPricing[1]);
      }
    });
  },
  
  /**
   * Update pricing display
   */
  updatePricingDisplay() {
    // This is called after calculatePricing() to update all price-related UI
    // Specific updates are handled in updateAll()
  }
};

// Make Buybox2 globally available
window.Buybox2 = Buybox2;

// Re-render punch when VWO assignment arrives (SmartCode is async).
window.addEventListener('bz:experiments', function () {
  if (window.Buybox2 && typeof window.Buybox2.updateRewardsPunchCard === 'function') {
    window.Buybox2.updateRewardsPunchCard();
  }
});

// Auto-initialize when DOM is ready
if (!window.__buybox2DeferInit) {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      if (document.getElementById('buybox-2-inline')) {
        Buybox2.init();
      }
    });
  } else if (document.getElementById('buybox-2-inline')) {
    Buybox2.init();
  }
}
